const tr = {
  // Genel
  loading: "Yükleniyor...",
  organizationLoadError: "Organizasyon verisi alınamadı.",
  organizationTitle: "Organizasyon Motoru",
  organizationSubtitle: "Pozisyon şablonları, kullanıcılar ve personel bağlantı durumu.",
  organizationPositionsLabel: "Pozisyon",
  organizationUsersLabel: "Kullanıcı",
  organizationPersonnelLabel: "Personel",
  organizationUnassignedUsersLabel: "Atanmamış Kullanıcı",
  organizationPositionsTitle: "Organizasyon Pozisyonları",
  organizationDepartment: "Departman",
  organizationSubDepartment: "Alt Departman",
  organizationJobTitle: "Ünvan",
  organizationLevel: "Seviye",
  organizationRole: "Rol",
  organizationUser: "Kullanıcı",
  organizationUnassigned: "Atanmamış",
  organizationUnassignedUsersTitle: "Atanmamış Kullanıcılar",
  organizationUnlinkedPersonnelTitle: "Kullanıcıya Bağlı Olmayan Personeller",
  organizationTenant: "Tenant",
  organizationFullName: "Ad Soyad",
  organizationDepartmentNameRequired: "Departman adı zorunlu.",
  organizationDepartmentSaveFailed: "Departman kaydedilemedi.",
  organizationDepartmentStatusFailed: "Departman durumu değiştirilemedi.",
  organizationSelectDepartment: "Departman seçiniz.",
  organizationPositionTitleRequired: "Pozisyon ünvanı zorunlu.",
  organizationPositionSaveFailed: "Pozisyon kaydedilemedi.",
  organizationPositionStatusFailed: "Pozisyon durumu değiştirilemedi.",
  organizationDepartmentNamePlaceholder: "Departman adı",
  organizationPositionTitlePlaceholder: "Ünvan",
  organizationOrderPlaceholder: "Sıra",
  organizationCodePlaceholder: "Kod",
  organizationSubDepartmentPlaceholder: "Alt departman",
  organizationRoleCodePlaceholder: "Rol kodu",
  save: "Kaydet",
  cancel: "İptal",
  delete: "Sil",
  edit: "Düzenle",
  add: "Ekle",
  search: "Ara",
  refresh: "Yenile",
  close: "Kapat",
  confirm: "Onayla",
  reject: "Reddet",
  total: "Toplam",
  status: "Durum",
  date: "Tarih",
  notes: "Notlar",
  actions: "İşlemler",
  detail: "Detay",
  create: "Oluştur",
  update: "Güncelle",
  success: "Başarılı",
  error: "Hata",
  warning: "Uyarı",
  logout: "Çıkış Yap",
  quantity: "Miktar",
  unit: "Birim",
  price: "Fiyat",
  customer: "Müşteri",
  supplier: "Tedarikçi",
  product: "Ürün",
  machine: "Makine",
  operator: "Operatör",
  department: "Departman",
  priority: "Öncelik",
  category: "Kategori",
  description: "Açıklama",
  noData: "Veri bulunamadı.",
  noMatch: "Eşleşen kayıt bulunamadı.",
  products: "Ürün Kartları",

  // Menü
  menu: {
    dashboard: "Dashboard",
    machines: "Makineler",
    workorders: "İş Emirleri",
    scrap: "Hurda & Geri Dönüşüm",
    quality: "Kalite & Sevkiyat",
    assembly: "Montaj",
    stock: "Stok",
    maintenance: "Bakım & Servis",
    energy: "Enerji",
    kaizen: "Kaizen",
    lean: "Lean",
    fives: "5S Denetim",
    hr: "İK & Bordro",
    reports: "Raporlar",
    shifts: "Vardiya Planlama",
    admin: "Fabrika Paneli",
    users: "Kullanıcı Yönetimi",
    organization: "Organizasyon",
    salesorders: "Satış Siparişleri",
    purchasing: "Satın Alma",
    products: "Ürün Kartları",
    qualityCost: "Kalite Maliyet",
  },

  superAdmin: {
    menu: {
      dashboard: "Dashboard",
      tenants: "Firmalar",
      users: "Kullanıcılar",
      licenses: "Lisanslar",
      payments: "Ödemeler",
      crm: "CRM",
      health: "Sunucu Sağlığı",
      backups: "Yedekleme",
      edge: "Edge Manager",
    },

    superAdminTitle: "Süper Admin",
    saasOverview: "SaaS Yönetim Özeti",
    upcomingWork: "Yaklaşan İşler",
    upcomingLicenseCenter: "🧾 Lisans merkezi hazırlanacak",
    upcomingPaymentArchitecture: "💳 Stripe + İyzico mimarisi kurulacak",
    upcomingCrmPipeline: "🤝 CRM pipeline eklenecek",
    upcomingServerHealth: "🖥️ Sunucu sağlık ekranı eklenecek",

    tenantManagement: "Firma Yönetimi",
    loading: "Yükleniyor...",
    plan: "Plan",
    user: "Kullanıcı",
    dataSource: "Veri Kaynağı",
    license: "Lisans",
    signIn: "Giriş Yap",
    edit: "Düzenle",
    extend: "Süre Uzat",
    delete: "Sil",

    licenseCenter: "Lisans Merkezi",
    packageLicenseSubtitle: "Deneme, Essentials, Professional, Advanced ve Enterprise paketleri ile lisans yenileme durumları",
    packageMatrixTitle: "Ticari Paketler",
    packageMatrixSubtitle: "Aktif paketlerin modül ve kapasite kapsamları",
    packageEssentialsDesc: "Canlı fabrika ve makine görünürlüğü, Dashboard ve temel operasyonel raporlama için Essentials paketi.",
    packageProfessionalDesc: "Essentials kapsamına ek olarak üretim yönetimi, iş emirleri, kalite, montaj, vardiya ve kurumsal operasyon süreçleri.",
    packageAdvancedDesc: "Professional kapsamına ek olarak bakım, enerji, kalite maliyeti, Kaizen, Lean ve 5S ile optimizasyon yetenekleri.",
    packageEnterpriseDesc: "Advanced kapsamına ek olarak kurumsal ölçek, entegrasyonlar, özel yapılandırmalar ve gelişmiş yönetim yetenekleri.",
    erpConnector: "ERP Connector",
    erpConnectorTitle: "ERP Connector Yönetimi",
    erpConnectorManage: "ERP Connector",
    erpConnectorEnabled: "Aktif",
    erpConnectorDisabled: "Pasif",
    erpConnectorGrantType: "Yetkilendirme Tipi",
    erpConnectorGrantAddon: "Ücretli Eklenti",
    erpConnectorGrantGift: "Hediye",
    erpConnectorGrantTrial: "Deneme",
    erpConnectorGrantManual: "Manuel",
    erpConnectorCurrency: "Para Birimi",
    erpConnectorMonthlyPrice: "Aylık Fiyat",
    erpConnectorYearlyPrice: "Yıllık Fiyat",
    erpConnectorStartsAt: "Başlangıç Tarihi",
    erpConnectorExpiresAt: "Bitiş Tarihi",
    erpConnectorNotes: "Not",
    erpConnectorNotesPlaceholder: "ERP sistemi, entegrasyon kapsamı veya ticari not...",
    erpConnectorSave: "ERP Connector Kaydet",
    erpConnectorSaved: "ERP Connector güncellendi.",
    erpConnectorSaveFailed: "ERP Connector kaydedilemedi.",
    erpConnectorConnectionError: "ERP Connector bağlantı hatası.",
    erpConnectorTenantMissing: "Firma bilgisi bulunamadı.",
    erpConnectorInvalidPrice: "Geçerli bir fiyat girin.",
    erpConnectorPrice: "ERP Connector Fiyatı",
    erpConnectorMonthly: "ay",

    moduleAddonManage: "Ek Modüller",
    moduleAddonTitle: "Ek Modül Yönetimi",
    moduleAddonSubtitle: "Ana pakete ek müşteri bazlı modül yetkileri ve ticari koşullar",
    moduleAddonModule: "Modül",
    moduleAddonEnabled: "Aktif",
    moduleAddonGrantType: "Yetkilendirme Tipi",
    moduleAddonGrantAddon: "Ücretli Eklenti",
    moduleAddonGrantGift: "Hediye",
    moduleAddonGrantTrial: "Deneme",
    moduleAddonGrantManual: "Manuel",
    moduleAddonCurrency: "Para Birimi",
    moduleAddonMonthlyPrice: "Aylık Fiyat",
    moduleAddonYearlyPrice: "Yıllık Fiyat",
    moduleAddonStartsAt: "Başlangıç Tarihi",
    moduleAddonExpiresAt: "Bitiş Tarihi",
    moduleAddonNotes: "Not",
    moduleAddonNotesPlaceholder: "Ticari kapsam veya müşteri özel notu...",
    moduleAddonSave: "Ek Modülü Kaydet",
    moduleAddonSaved: "Ek modül güncellendi.",
    moduleAddonDeleted: "Ek modül kaldırıldı.",
    moduleAddonLoadFailed: "Ek modüller yüklenemedi.",
    moduleAddonSaveFailed: "Ek modül kaydedilemedi.",
    moduleAddonDeleteFailed: "Ek modül kaldırılamadı.",
    moduleAddonDeleteConfirm: "Bu ek modül kaydı kaldırılsın mı?",
    moduleAddonModuleRequired: "Modül seçin.",
    moduleAddonInvalidPrice: "Geçerli bir fiyat girin.",
    moduleAddonCurrent: "Tanımlı Ek Modüller",
    moduleAddonNone: "Bu firma için ek modül tanımlı değil.",
    moduleAddonEdit: "Düzenle",
    moduleAddonRemove: "Kaldır",
    userLimit: "Kullanıcı Limiti",
    machineLimit: "Makine Limiti",
    usersCommercial: "Kullanıcı",
    unlimited: "Sınırsız",
    machineLicensing: "Lisanslama",
    perMachineMonthly: "Makine başına / aylık",
    machinePricingTitle: "Makine Başı Fiyatlandırma",
    machinePricingSubtitle: "Essentials, Professional, Advanced ve Enterprise paketleri için aylık makine başı fiyat kataloğu",
    machinePriceEdit: "Fiyatları Düzenle",
    machinePriceModalTitle: "Makine Başı Fiyat",
    machinePriceMonthly: "Makine / Ay",
    machinePriceNotConfigured: "Tanımlanmadı",
    machinePriceHelp: "Bu fiyatlar paket bazında bir makinenin aylık lisans bedelidir. Kullanıcı sayısı sınırsızdır. ERP Connector ayrıca fiyatlandırılır.",
    machinePriceSave: "Fiyatları Kaydet",
    machinePriceSaved: "Makine başı fiyatlar güncellendi.",
    machinePriceSaveFailed: "Makine başı fiyatlar kaydedilemedi.",
    machinePriceInvalid: "TRY, USD ve EUR için sıfır veya daha büyük geçerli fiyat girin.",
    machinePricePlanMissing: "Paket bilgisi bulunamadı.",
    editPlan: "Plan Düzenle",
    editLicense: "Lisans Düzenle",
    noPlan: "Plan yok",
    renewalSoon: "Yenileme Yakın",
    expired: "Süresi Doldu",
    planTrial: "Deneme",
    realMachine: "Gerçek",
    simulation: "Simülasyon",
    days: "gün",

    price: "Fiyat",
    endDate: "Bitiş",
    status: "Durum",
    unknown: "Belirsiz",
    daysRemaining: "gün kaldı",
    limit: "Limit",
    usersUnit: "kullanıcı",
    machinesUnit: "makine",
    email: "E-posta",

    paymentCenter: "Ödeme Merkezi",
    paymentArchitecture: "Ödeme Mimarisi",
    paymentTryInfo: "🇹🇷 TRY ödemeler: İyzico abonelik / ödeme linki",
    paymentForeignInfo: "🌍 USD / EUR ödemeler: Stripe Checkout / Subscription",
    paymentLicenseLinkInfo: "🧾 Her ödeme tenant lisans süresine bağlanacak",
    paymentWebhookInfo: "🔐 Webhook doğrulaması backend tarafında yapılacak",

    tryCollection: "TRY Tahsilat",
    tryCollectionDesc: "Türkiye müşterileri için İyzico",
    usdCollection: "USD Tahsilat",
    usdCollectionDesc: "Yurt dışı müşterileri için Stripe",
    eurCollection: "EUR Tahsilat",
    eurCollectionDesc: "Avrupa müşterileri için Stripe",

    crmPipeline: "CRM Pipeline",
    crmLeadApiPending: "Lead ekleme API sonraki adımda eklenecek",
    crmLead: "Lead",
    crmLeadDesc: "İlk temas / potansiyel müşteri",
    crmDemo: "Demo",
    crmDemoDesc: "Demo planlanan veya yapılan firma",
    crmTrial: "Trial",
    crmTrialDesc: "Deneme hesabı aktif olan firma",
    crmCustomer: "Customer",
    crmCustomerDesc: "Ücretli müşteriye dönüşen firma",

    serverHealth: "Sunucu Sağlığı",
    systemInformation: "Sistem Bilgileri",
    uptime: "Uptime",
    lastCheck: "Son kontrol",
    lastBackup: "Son backup",
    backupSize: "Backup boyutu",
    totalBackups: "Toplam backup",

    tenantBackupCenter: "Tenant Yedekleme Merkezi",
    latestBackup: "Son yedek",
    latestBackupSize: "Son yedek boyutu",
    totalSize: "Toplam boyut",
    healthy: "Sağlıklı",
    empty: "Boş",
    backupRunning: "Alınıyor...",
    takeBackup: "Yedek Al",
    backupHistoryPending: "Yedek geçmişi API sonraki adımda bağlanacak",
    restoreFlowPending: "Geri yükleme güvenli onay akışıyla eklenecek",

    userManagement: "Kullanıcı Yönetimi",
    allCompanies: "Tüm firmalar",
    company: "Firma",
    role: "Rol",
    lastLogin: "Son Giriş",
    actions: "İşlemler",
    password: "Şifre",

    editCompany: "Firma Düzenle",
    addCompany: "Yeni Firma Ekle",
    companyName: "Firma Adı",
    subdomain: "Subdomain",
    phone: "Telefon",
    simulationOption: "🔬 Simülasyon",
    realMachineOption: "🏭 Gerçek Makine",
    maxUsers: "Max Kullanıcı",
    cancel: "İptal",
    save: "Kaydet",

    currency: "Para Birimi",
    statusActive: "Aktif",
    statusTrial: "Deneme",
    statusExpired: "Süresi Doldu",
    statusCancelled: "İptal",
    trialEndDate: "Trial Bitiş Tarihi",

    editUser: "Kullanıcı Düzenle",
    addUser: "Yeni Kullanıcı Ekle",
    username: "Kullanıcı Adı",

    roleAdmin: "Admin",
    roleManager: "Müdür",
    roleTechnician: "Teknisyen",
    roleOperator: "Operatör",
    roleQuality: "Kalite",

    select: "Seç...",

    confirmManualBackup: "Şimdi manuel yedek alınsın mı?",
    confirmDeleteTenant: "Bu firmayı silmek istediğinizden emin misiniz?",
    promptNewPassword: "Yeni şifre:",
    confirmDeleteUser: "Bu kullanıcı silinsin mi?",
    confirmImpersonateTenant: "Bu firma hesabına süper admin olarak giriş yapılsın mı?",
    promptExtendMonths: "Kaç ay uzatılsın? (1, 3, 6, 12)",

    backupFailed: "Backup alınamadı",
    backupCreated: "Backup oluşturuldu ✓",
    backupConnectionError: "Backup bağlantı hatası",

    licenseUpdated: "Lisans güncellendi ✓",
    licenseUpdateFailed: "Lisans güncellenemedi",
    licenseConnectionError: "Lisans bağlantı hatası",

    userCreated: "Kullanıcı oluşturuldu ✓",
    passwordReset: "Şifre sıfırlandı ✓",
    userUpdated: "Kullanıcı güncellendi ✓",
    userUpdateFailed: "Kullanıcı güncellenemedi",
    userDeleted: "Kullanıcı silindi ✓",
    userDeleteFailed: "Kullanıcı silinemedi",

    tenantLoginError: "Tenant giriş hatası",
    genericError: "Hata oluştu",
    connectionError: "Bağlantı hatası",
  },

  // Dashboard
  dashboard: {
    factoryOee: "Fabrika OEE",
    totalProduction: "Toplam Üretim",
    activeAlarms: "Aktif Alarmlar",
    monthlyLoss: "Aylık Kayıp",
    machineStatus: "Makine Durumu",
    lastAlarms: "Son Alarmlar",
    oeeDesc: "Genel Ekipman Verimliliği",
    productionDesc: "Toplam üretilen parça",
    alarmDesc: "Bekleyen alarm sayısı",
    lossDesc: "Tahmini üretim kaybı",

    // Dashboard Final
    refresh: "Yenile",
    refreshing: "Yenileniyor",
    live: "CANLI",
    waitingForData: "Veri bekleniyor",
    updatedJustNow: "Az önce güncellendi",
    secondsAgo: "sn önce",
    refreshTitle: "Dashboard verilerini yenile",
    lightTheme: "Açık Tema",
    darkTheme: "Koyu Tema",
    switchToLightTheme: "Açık temaya geç",
    switchToDarkTheme: "Koyu temaya geç",
    viewAll: "Tümünü Gör",
    viewAllArrow: "Tümünü Gör →",

    machine: "Makine",
    oee: "OEE",
    program: "Program",
    progress: "İlerleme",

    factoryBrain: "Fabrika Beyni",
    noActiveRecommendations: "Aktif öneri bulunmuyor.",
    viewAllAnalyses: "Tüm Analizleri Gör →",

    profitLoss: "Kar & Zarar Özeti",
    last30Days: "Son 30 Gün",
    totalRevenue: "Toplam Gelir",
    totalExpense: "Toplam Gider",
    grossProfit: "Brüt Kâr",
    grossMargin: "Brüt Kâr Marjı",

    time: "Zaman",
    alarmCode: "Alarm Kodu",
    description: "Açıklama",
    status: "Durum",
    noActiveAlarms: "Aktif alarm bulunmuyor.",
    activeMachineAlarm: "Aktif makine alarmı",

    // Satış Dashboard
    salesOrderCount: "SİPARİŞ SAYISI",
    salesLast30Days: "Son 30 gün",
    salesPendingOrders: "BEKLEYEN SİPARİŞ",
    salesPendingOrdersDesc: "Planlama / üretim sürecinde",
    salesWaitingShipment: "SEVKİYAT BEKLEYEN",
    salesWaitingShipmentDesc: "Hazır / sevk bekliyor",
    salesCompleted: "TAMAMLANAN",
    salesCompletedDesc: "Tamamlanan / sevk edilen",
    salesInvoicePending: "FATURA BEKLEYEN",
    salesInvoicePendingDesc: "Faturalandırma bekliyor",
    salesCustomerCount: "MÜŞTERİ SAYISI",
    salesCustomerCountDesc: "Yetkili müşteri kapsamı",
    salesCancelled: "İPTAL / RED",
    salesCancelledDesc: "İptal veya reddedilen",

    recentSalesOrders: "Son Satış Siparişleri",
    orderNo: "Sipariş No",
    customer: "Müşteri",
    amount: "Tutar",

    topSellingProducts: "En Çok Satılan Ürünler",
    product: "Ürün",
    quantity: "Adet",

    // Dashboard Final Freeze
    mainModules: "Ana Modüller",
    backToSuperAdmin: "Süper Admin'e Dön",
    noNotifications: "Bildirim yok",
    notifications: "Bildirimler",
    markAllRead: "Tümünü okundu işaretle",

    salesMonthAmount: "BU AY SATIŞ",
    salesMonthAmountDesc: "Yetkili satış kapsamı",

    severityHigh: "Yüksek",
    severityInfo: "Bilgi",

    moduleSuffix: "modülü",

    statusRunning: "Çalışıyor",
    statusFault: "Arıza",
    statusStopped: "Durduruldu",
    statusIdle: "Bekliyor",
    statusOffline: "Çevrimdışı",
    statusSetup: "Ayar",
    statusMaintenance: "Bakım",
    statusToolChange: "Takım Değişimi",
    statusUnknown: "Bilinmiyor",
  },

  // Makine durumları
  machineStatus: {
    running: "Çalışıyor",
    fault: "Arıza",
    offline: "Kapalı",
    maintenance: "Bakımda",
    idle: "Bekliyor",
    stopped: "Durdu",
  },

  // Alarm
  alarmLevel: {
    KRITIK: "Kritik",
    UYARI: "Uyarı",
    NORMAL: "Normal",
  },

  // İş Emirleri
  workorders: {
    title: "İş Emirleri",
    subtitle: "Üretim planlama · MRP · Kapasite · Maliyet takibi",
    new: "+ Yeni İş Emri",
    orderNo: "Sipariş No",
    deadline: "Termin",
    progress: "İlerleme",
    startProduction: "🏭 Üretime Al",
    sourceOrder: "Kaynak Sipariş",
    assignedMachine: "Makine Ata",
    assignedOperator: "Operatör Ata",
    noOrders: "Henüz iş emri yok.",
    noMatch: "Filtrelerle eşleşen iş emri bulunamadı.",
    allStatuses: "Tüm Durumlar",
    allPriorities: "Tüm Öncelikler",
    inProduction: "Üretimde",
    completed: "Tamamlandı",
    released: "Serbest",
    status: {
      draft: "Taslak",
      planned: "Planlandı",
      released: "Serbest",
      in_progress: "Üretimde",
      assembly_pending: "Montaj Bekliyor",
      assembly_in_progress: "Montajda",
      assembly_done: "Montaj Tamamlandı",
      completed: "Tamamlandı",
      closed: "Kapatıldı",
      cancelled: "İptal",
    },
    priority: {
      low: "Düşük",
      normal: "Normal",
      high: "Yüksek",
      urgent: "Acil",
      critical: "Kritik",
    },
    tabs: {
      overview: "📋 Genel",
      production: "🏭 Operasyon",
      materials: "📋 Ürün Reçetesi",
      revisions: "🔁 Revizyonlar",
      audit: "📜 Geçmiş",
    },
    plannedQty: "Planlanan Miktar",
    producedQty: "Üretilen Miktar",
    createdBy: "Oluşturan",
    completion: "Tamamlanma",
    materialCheck: "Malzeme Kontrolü",
    sufficient: "Yeterli",
    insufficient: "Eksik",
    noBom: "Bu ürün için BOM tanımlanmamış veya malzeme bilgisi bulunamadı.",
    materialNeeded: "Gereken",
    materialAvailable: "Mevcut",
    purchaseCreated: "Satın Alma Talepleri Oluşturuldu",
    purchaseInfo: "Talepler Satın Alma departmanına iletildi.",
    noManagerPermission: "Üretime almak için üretim müdürü yetkisi gerekiyor.",
    alreadyInProduction: "Bu iş emri zaten üretimde.",
    materialInfo: "\"Üretime Al\" butonuna basıldığında sistem malzeme kontrolü yapar.",
    // Maliyet
    stdCost: "Standart Maliyet",
    actCost: "Fiili Maliyet",
    variance: "Varyans",
    saving: "Tasarruf",
    overrun: "Aşım",
    stdVsAct: "Standart vs Fiili Karşılaştırma",
    item: "Kalem",
    standard: "Standart",
    actual: "Fiili",
    statusLabel: "Durum",
    material: "Malzeme",
    labor: "İşçilik",
    overhead: "Genel Gider",
    scrap: "Hurda",
    loss: "Kayıp",
    notEntered: "Girilmedi",
    total: "TOPLAM",
    actCostEntry: "Fiili Maliyet Girişi",
    costSaved: "Fiili maliyetler kaydedildi",
    totalActual: "Toplam fiili",
    // Form
    editOrder: "İş Emri Düzenle",
    productionType: "Üretim Tipi",
    prodForCustomer: "Siparişe Üretim",
    prodForCustomerDesc: "Müşteri siparişi için",
    prodForStock: "Stoğa Üretim",
    prodForStockDesc: "Fabrika deposu için",
    customerL: "Müşteri",
    customerName: "Müşteri Adı",
    searchCustomer: "Müşteri ara...",
    stockOrderNo: "Stok Emri No",
    stockOrderNote: "Üretilen ürünler fabrika deposuna eklenecek.",
    product_: "Ürün",
    productName: "Ürün Adı",
    productCode: "Ürün Kodu",
    searchProduct: "Ürün ara...",
    stock_: "Stok",
    mrpCalc: "MRP hesaplanıyor...",
    mrpCostSummary: "MRP / Maliyet Özeti",
    rawMaterial: "Hammadde",
    outsource: "Fason",
    laborSgk: "İşçilik+SGK",
    unitCost: "Birim Maliyet",
    mrpShortage: "Eksik malzeme var! Üretim öncesi satın alma gerekiyor.",
    rawMaterialStatus: "Hammadde Durumu",
    needed: "Gerekli",
    inWarehouse: "Depoda",
    outsourceOps: "Fason İşlemler",
    totalCostFor: "Toplam maliyet",
    qty: "Miktar",
    unit_: "Birim",
    pcs: "Adet",
    productionPlan: "Üretim Planı",
    start: "Başlangıç",
    deadlineWorkdays: "Termin (iş günü)",
    deadlineDate: "Termin Tarihi",
    machine_: "Makine",
    machineIdPlaceholder: "Makine ID",
    operatorKiosk: "Operatör (Kiosk)",
    selectOperator: "Operatör Seç",
    priority_: "Öncelik",
    notes_: "Notlar",
    cancel_: "İptal",
    saving_: "Kaydediliyor...",
    update_: "Güncelle",
    create_: "Oluştur",
    // Detay
    orderInfo: "İş Emri Bilgileri",
    productionStatus: "Üretim Durumu",
    salesQty: "Satış Sipariş Miktarı",
    sourceOrder_: "Kaynak Sipariş",
    operator_: "Operatör",
    edit: "Düzenle",
    cancelOrder: "İptal Et",
    cancelConfirm: "İş emrini iptal etmek istediğinizden emin misiniz?",
    cancelInProgressNote: "Üretilip sevk edilmemiş ürünler fabrika stokuna eklenecek.",
    createDepotOrder: "Kalan miktar için depo stok iş emri (DPO) oluştur",
    cancelReasonPlaceholder: "İptal sebebi yazınız... (zorunlu)",
    yesCancelIt: "Evet, İptal Et",
    goBack: "Vazgeç",
    cancelReasonRequired: "İptal sebebi zorunludur.",
    cancelFailed: "İptal başarısız.",
    cancelled_: "İş emri iptal edildi.",
    cancelledWithStock: "İş emri iptal edildi. {n} adet ürün fabrika stokuna eklendi.",
    assignMachineOp: "Makine & Operatör Ata",
    select: "Seçin...",
    processing: "İşleniyor...",
    okClose: "Tamam, Kapat",
    shortage_: "Eksik",
    requestNo: "Talep No",
    available_: "Mevcut",
    cost: "Maliyet",
    // Ana liste
    statTotal: "Toplam",
    refresh: "Yenile",
    searchPlaceholder: "Sipariş no, ürün veya müşteri ara...",
    orderCount: "iş emri",
    loading_: "Yükleniyor...",
    retry: "Tekrar Dene",
    errFetch: "İş emirleri alınamadı",
    errGeneric: "Bir hata oluştu",
    connectionError: "Bağlantı hatası",
    approveOrderConfirm: "iş emri onaylansın mı?",
    approveFailed: "Onay işlemi başarısız",
    orderApproved: "İş emri onaylandı.",
    approveError: "Onay işlemi sırasında hata oluştu.",
    rejectOrderPrompt: "iş emri neden reddediliyor?",
    rejectFailed: "Red işlemi başarısız",
    orderRejected: "İş emri reddedildi.",
    rejectError: "Red işlemi sırasında hata oluştu.",
    treeLoadFailed: "İş emri ağacı alınamadı",

    downtimeReasonLabel: "Duruş nedeni",
    durationLabel: "Süre",
    selectDowntimeReason: "Duruş Nedeni Seç",
    downtimeDurationLabel: "Duruş süresi",

    // Runtime / production action messages
    runtimeStatusLoadFailed: "Runtime durumu alınamadı.",
    downtimeReasonsLoadFailed: "Duruş nedenleri alınamadı.",
    activeDowntimeLoadFailed: "Aktif duruş bilgisi alınamadı.",
    downtimeDescriptionLabel: "Açıklama",
    downtimeNoteRequired: "Bu duruş nedeni için açıklama girilmesi zorunludur.",
    downtimeReasonSaveFailed: "Duruş nedeni kaydedilemedi.",
    assignedMachineNotFound: "İş emrine atanmış makine bulunamadı.",
    runtimeStartConfirm: "Bu iş emri için üretim runtime kaydı başlatılacaktır.\n\nBu işlem CNC makinesini fiziksel olarak çalıştırmaz.",
    runtimeStartFailed: "Üretim runtime kaydı başlatılamadı.",
    materialShortageProductionBlocked: "Eksik malzeme var. Malzeme tamamlanmadan üretim başlatılamaz.",

    // Materials / revisions / audit / actions
    revisionEmpty: "Revizyon kaydı bulunamadı.",
    auditActionWorkOrderUpdated: "İş Emri Güncellendi",
    auditDescriptionWorkOrderUpdated: "İş emri bilgileri güncellendi",
    auditEmpty: "Geçmiş kayıt bulunamadı.",
    revisionQuantity: "Miktar",
    revisionDeadline: "Termin",
    revisionPriority: "Öncelik",
    revisionReason: "Sebep",
    treeAction: "Ağaç",
    detailAction: "Detay",
    treeTitle: "İş Emri Ağacı",
    treeLoading: "Ağaç yükleniyor...",
    treeNoData: "Ağaç verisi bulunamadı.",
    approval: "Onay",
    approvalApproved: "Onaylandı",
    approvalRejected: "Reddedildi",
    approvalPending: "Bekliyor",
    dependencyReady: "Hazır",
    dependencyWaitingChildren: "Alt iş emirleri bekleniyor",
    dependencyBlocked: "Blokeli",
    dependencyPending: "Beklemede",
    internalQc: "İç Proses KK",
    finalQcWaiting: "Final KK Bekliyor",
    treeProductFallback: "Ürün",
    recordUnit: "kayıt",
    errProductQtyRequired: "Ürün adı ve miktar zorunlu.",
    detail_: "Detay",
    actions_: "İşlem",
    createdAt: "Oluşturma",
    save: "Kaydet",
    error: "Hata",
    prodQty: "Üretim Miktarı",

    // Runtime / canlı üretim
    runtimeReady: "🟦 Hazır",
    runtimePaused: "⏸ Duraklatıldı",
    runtimeNotFound: "— Runtime bulunamadı",
    machineRealStatus: "Makine Gerçek Durumu",
    machineNoConnection: "⚫ Bağlantı yok",
    machineRunningLive: "🟢 Makine çalışıyor",
    machineStoppedLive: "🟡 Makine durdu",
    machineDowntimeDetected: "⚠️ Makine duruşu algılandı",
    downtimePlanned: "Planlı duruş",
    downtimeUnplanned: "Plansız duruş",
    downtimeDescriptionRequired: " · Açıklama gerekli",
    downtimeReasonsLoading: "Duruş nedenleri yükleniyor...",
    noDowntimeReason: "Duruş nedeni bulunamadı.",
    downtimeDescriptionPlaceholder: "Gerekirse kısa açıklama girin...",
    startingProduction: "Başlatılıyor...",
    startRuntimeProduction: "▶ Üretimi Başlat",
    startProductionFirst: "Önce üretimi başlatın.",
    cannotCompleteMachineOffline: "Makine bağlantısı yokken üretim tamamlanamaz.",
    cannotCompleteMachineRunning: "Makine çalışırken üretim tamamlanamaz.",
    startProductionFirstButton: "▶ Önce Üretimi Başlatın",
    machineConnectionMissingButton: "⚫ Makine Bağlantısı Yok",
    stopMachineFirstButton: "⛔ Önce Makineyi Durdurun",
    completeRuntimeProduction: "✅ Üretimi Tamamla",
    whyMachineStopped: "Makine Neden Durdu?",
    machineStatusLabel: "Makine durumu:",
    downtimeOperator: "Operatör",

    // Runtime screen final localization
    mesStatus: "MES Durumu",
    checkingStatus: "Kontrol ediliyor...",
    runtimeActive: "▶ Aktif",
    machineStatusUnknown: "⚪ Durum bilinmiyor",
    runtimeMachineWaitingWarning: "⚠️ MES üretimi aktif ancak makine henüz çalışmıyor. CNC panelindeki güvenlik kontrollerinden sonra operatör Cycle Start uygulamalıdır.",
    downtimeReasonInfo: "Bu seçim CNC makinesini çalıştırmaz veya durdurmaz. Yalnızca gerçekleşen duruşun nedenini kaydeder.",
    checkStatus: "🔄 Durumu Kontrol Et",
    producedQuantity: "Üretilen Adet",

},

  // Satış Siparişleri
  salesorders: {
    title: "Satış Siparişleri",
    subtitle: "Müşteri siparişleri · Onay akışı · Üretim takibi",
    new: "+ Yeni Sipariş",
    orderNo: "Sipariş No",
    itemCount: "Kalem Sayısı",
    delivery: "Termin",
    createdBy: "Oluşturan",
    domestic: "Yurt İçi",
    foreign: "Yurt Dışı",
    startProduction: "🏭 Üretime Başla",
    approve: "✅ Onayla",
    reject: "✗ Reddet",
    cancel: "🗑️ İptal",
    draft: "Taslak",
    inProduction: "Üretimde",
    readyToShip: "Sevkiyata Hazır",
    completedOrders: "Tamamlanan",
    noOrders: "Henüz sipariş yok. Yeni sipariş oluşturun.",
    noMatch: "Eşleşen sipariş bulunamadı.",
    allStatuses: "Tüm Durumlar",
    status: {
      draft: "Taslak",
      pending_approval: "Onay Bekliyor",
      approved: "Onaylandı",
      rejected: "Reddedildi",
      in_production: "Üretimde",
      ready: "Sevkiyata Hazır",
      shipped: "Sevk Edildi",
      completed: "Tamamlandı",
      cancelled: "İptal",
    },
  },

  // Satış Siparişleri — SalesOrders.js için genişletilmiş blok
  salesOrders: {
    title: "Satış Siparişleri",
    subtitle: "Müşteri siparişleri · Onay akışı · Üretim takibi",
    newOrder: "Yeni Sipariş",
    editOrder: "Siparişi Düzenle",
    newCustomer: "Yeni Müşteri",
    addNewCustomer: "Yeni Müşteri Ekle",
    saveCustomer: "Müşteriyi Kaydet",
    customerInfo: "Müşteri / Cari Bilgileri",
    customerName: "Müşteri / Firma Adı",
    customerType: "Tür",
    searchCustomer: "Müşteri Ara",
    customerSearchPlaceholder: "Müşteri adı veya kodu...",
    customer: "Müşteri",
    domestic: "Yurt İçi",
    foreign: "Yurt Dışı",
    city: "Şehir",
    phone: "Telefon",
    email: "E-posta",
    assignedSalesRep: "Atanan Satış Temsilcisi",
    unassigned: "Atanmamış",
    orderDate: "Sipariş Tarihi",
    deliveryDate: "Termin Tarihi",
    notes: "Notlar",
    orderItems: "Sipariş Kalemleri",
    addItem: "Kalem Ekle",
    item: "Kalem",
    productName: "Ürün Adı",
    searchProduct: "Ürün ara...",
    selectFromListWarning: "Listeden bir ürün seçmelisiniz",
    available: "Kullanılabilir",
    noStock: "Stok Yok — Üretim Gerekli",
    allReserved: "Depoda var ama tümü ayrılmış",
    total: "Toplam",
    totalLabel: "toplam",
    reserved: "Ayrılmış",
    quantity: "Miktar",
    unit: "Birim",
    unitPcs: "Adet",
    unitPrice: "Birim Fiyat",
    selected: "Seçili",
    close: "Kapat",
    cancel: "İptal",
    saving: "Kaydediliyor...",
    create: "Oluştur",
    saveOrder: "Siparişi Kaydet",
    update: "Güncelle",
    edit: "Düzenle",
    approve: "Onayla",
    reject: "Reddet",
    startProduction: "Üretime Başla",
    processing: "İşleniyor...",
    detail: "Detay",
    orderInfo: "Sipariş Bilgileri",
    orderNo: "Sipariş No",
    createdBy: "Oluşturan",
    approvedBy: "Onaylayan",
    productionStatus: "Üretim Durumu",
    totalItems: "Toplam Kalem",
    inProduction: "Üretimde",
    inProductionLabel: "üretimde",
    qcPassed: "KK Geçti",
    qcShort: "KK",
    waiting: "Bekliyor",
    waitingLabel: "bekliyor",
    qcCompletion: "KK Tamamlanma",
    qcPass: "Geçti",
    qcPartial: "Kısmi",
    qcFail: "Başarısız",
    passed: "geçti",
    scrap: "fire",
    rejectionReason: "Red Gerekçesi",
    rejectionPlaceholder: "Neden reddedildi?",
    rejectionReasonLabel: "Red gerekçesi",
    loading: "Yükleniyor...",
    detailError: "Detay alınamadı",
    invoiceHistory: "Fatura Geçmişi",
    invoiceAndShipping: "Fatura & Sevkiyat Bilgileri",
    invoiced: "Fatura Kesildi",
    invoiceNo: "Fatura No",
    invoiceDate: "Fatura Tarihi",
    newInvoice: "Yeni Fatura",
    deliveryNoteNo: "İrsaliye No",
    cargoCompany: "Kargo Firması",
    cargoPlaceholder: "Yurtiçi, Aras...",
    trackingNo: "Takip No",
    trackingPlaceholder: "Kargo takip no",
    tracking: "Takip",
    date: "Tarih",
    amount: "Tutar",
    issuedBy: "Kesen",
    invoiceWarning: "Fatura kesilmeden sevkiyat yapılamaz. Fatura bilgilerini girin.",
    markAsInvoiced: "Fatura Kesildi Olarak İşaretle",
    customerConfirmed: "Müşteri teslim aldı",
    customerDelivered: "Müşteri Teslim Aldı",
    product: "Ürün",
    code: "Kod",
    workOrder: "İş Emri",
    machine: "Makine",
    operator: "Operatör",
    status: "Durum",
    action: "İşlem",
    shipping: "Sevkiyat",
    shipped: "sevk edildi",
    readyToShip: "sevke hazır",
    remaining: "kalan",
    missingShipment: "Eksik sevkiyat!",
    itemCount: "Kalem Sayısı",
    productionPlanResult: "Üretim Planı Sonucu",
    allFromStock: "Tüm kalemler depoda mevcut — Sipariş sevkiyata hazır!",
    fromStock: "Depodan",
    mixed: "Karma",
    ok: "Tamam",
    searchPlaceholder: "Sipariş no veya müşteri ara...",
    allStatuses: "Tüm Durumlar",
    noOrders: "Henüz sipariş yok.",
    noMatch: "Eşleşen sipariş bulunamadı.",
    orderCount: "sipariş",
    statTotal: "Toplam",
    alreadyInList: "zaten listede var.",
    confirmCancel: "Siparişi iptal etmek istediğinize emin misiniz?",
    cancelReasonPrompt: "İptal sebebi (opsiyonel):",
    cancelled: "İptal edildi",
    errCustomerNameRequired: "Müşteri adı zorunlu.",
    errSelectCustomer: "Müşteri seçiniz.",
    errSelectFromList: "Lütfen tüm kalemlerde listeden bir ürün seçin.",
    errAllFieldsRequired: "Tüm kalemlerin ürün adı ve miktarı zorunlu.",
    errDuplicateProduct: "Aynı ürün birden fazla kalemde var.",
    errInvoiceNoRequired: "Fatura numarası zorunlu.",
    errGeneric: "Hata",
    errOrdersFetch: "Siparişler alınamadı",
    errConnection: "Bağlantı hatası",
    statusDraft: "Taslak",
    statusPendingApproval: "Onay Bekliyor",
    statusApproved: "Onaylandı",
    statusRejected: "Reddedildi",
    statusInProduction: "Üretimde",
    statusReady: "Sevkiyata Hazır",
    statusShipped: "Sevk Edildi",
    statusCompleted: "Tamamlandı",
    statusClosed: "Kapandı",
    orderItemCount: "Sipariş Kalemi",
    orderQuantity: "Sipariş Adedi",
    qcPassedQty: "KK Geçen",
    waitingQty: "Bekleyen",
    salesRep: "Satış Temsilcisi",
    salesRegion: "Bölge",
    statusCancelled: "İptal",
    statusPartialShipped: "Kısmi Sevkiyat",
    statusQcPending: "Final KK Bekliyor",
    statusQcPassed: "KK Geçti",
    statusAssemblyPending: "Montaj Bekliyor",
    statusAssemblyInProgress: "Montajda",
    statusAssemblyDone: "Montaj Tamamlandı",
    exportRegion: "İhracat",
    domesticRegion: "Yurt İçi",
    recordUnit: "kayıt",
    dayShift: "Gündüz",
    errOrderIdMissing: "Sipariş ID bulunamadı. Sayfayı yenileyip tekrar deneyin.",
    submitForApproval: "Onaya Gönder",
    adminApprovalPending: "Admin Onayı Bekleniyor",
    approvalByUser: "{user} onayladı",
  },

  // Stok
  stock: {
    title: "Stok Yönetimi",
    materialName: "Malzeme Adı",
    currentStock: "Mevcut Stok",
    minStock: "Min. Stok",
    unitPrice: "Birim Fiyat",
    totalValue: "Toplam Değer",
    status: {
      sufficient: "Yeterli",
      low: "Düşük",
      critical: "Kritik",
      empty: "Tükendi",
    },
  },

  // Kalite
  quality: {
    title: "Kalite Kontrol & Sevkiyat",
    orderNo: "İş Emri No",
    checked: "Kontrol Edilen",
    passed: "Geçen",
    failed: "Başarısız",
    passRate: "Geçiş Oranı",
    inspector: "Kontrol Eden",
    status: {
      passed: "✅ Geçti",
      failed: "✗ Başarısız",
      partial: "⚠ Kısmi",
      pending: "Bekliyor",
    },
  },

  // Bakım
  maintenance: {
    title: "Bakım & Servis",
    type: "Bakım Tipi",
    technician: "Teknisyen",
    scheduledDate: "Planlanan Tarih",
    duration: "Süre (dk)",
    status: {
      pending: "Bekliyor",
      in_progress: "Devam Ediyor",
      completed: "Tamamlandı",
      cancelled: "İptal",
    },
  },

  // Enerji
  energy: {
    title: "Enerji Takibi",
    todayKwh: "Bugün (kWh)",
    todayCost: "Bugün Maliyet",
    monthKwh: "Bu Ay (kWh)",
    monthCost: "Bu Ay Maliyet",
    currentPower: "Anlık Güç (kW)",
    co2: "CO₂ Emisyonu",
  },

  // İK
  hr: {
    title: "İK & Bordro",
subtitle: "Çalışan yönetimi · Devam takibi · Bordro hesaplama",
refresh: "Yenile",
    employee: "Çalışan",
    grossSalary: "Brüt Maaş",
    netSalary: "Net Maaş",
    workDays: "Çalışma Günü",
    overtime: "Fazla Mesai",
    sgk: "SGK İşçi",
    tax: "Gelir Vergisi",

    status: {
      present: "Mevcut",
      absent: "Devamsız",
      late: "Geç",
      leave: "İzinli",
    },

    employeeStatus: {
      active: "Aktif",
      inactive: "Pasif",
      leave: "İzinde",
      terminated: "Ayrıldı",
    },

    attendanceStatus: {
      present: "Geldi",
      absent: "Gelmedi",
      late: "Geç Kaldı",
      leave: "İzinli",
      holiday: "Tatil",
    },

    leaveTypes: {
      annual: "Yıllık İzin",
      sick: "Hastalık İzni",
      maternity: "Doğum İzni",
      unpaid: "Ücretsiz İzin",
      excused: "Mazeret İzni",
    },

    tabs: {
      profile: "Profil",
      attendance: "Devam Takibi",
      leaves: "İzinler",
      payslips: "Bordro",
    },

    // HR Localization RC1.4C.1
    addEmployee: "Çalışan Ekle",
    totalEmployees: "Toplam Çalışan",
    activeEmployees: "Aktif",
    presentToday: "Bugün Gelen",
    onLeaveEmployees: "İzinde",
    monthlyPayroll: "Aylık Bordro",

    mainTabs: {
      employees: "👤 Çalışanlar",
      attendance: "📋 Devam Takibi",
      payroll: "💰 Bordro",
      competency: "🎯 Yetkinlik Matrisi",
      training: "📚 Eğitim",
      performance: "⭐ Performans",
      orgchart: "🏗️ Org Şeması",
      worksettings: "⚙️ Çalışma Ayarları",
      timesheet: "📊 Puantaj",
      autopayroll: "🧮 Otomatik Bordro",
    },

    loading: "Yükleniyor...",
    retry: "Tekrar Dene",
    employeeSearchPlaceholder: "🔍 Ad, soyad veya sicil no ara...",
    allDepartments: "Tüm Departmanlar",
    allStatuses: "Tüm Durumlar",
    noEmployees: "Henüz çalışan kaydı yok.",
    noMatchingEmployees: "Eşleşen çalışan bulunamadı.",
    noEmployeeData: "Çalışan verisi bulunamadı",

    departments: {
      production: "Üretim",
      quality: "Kalite",
      maintenance: "Bakım",
      planning: "Planlama",
      warehouse: "Depo",
      purchasing: "Satın Alma",
      hr: "İK",
      accounting: "Muhasebe",
      management: "Yönetim",
      foreignTrade: "Dış Ticaret",
      domesticSales: "Yurt İçi Satış",
    },

    roles: {
      operator: "Operatör",
      technician: "Teknisyen",
      warehouse: "Depo",
      manager: "Yönetici",
      admin: "Admin",
      quality: "Kalite",
      planner: "Planlama",
      maintenance: "Bakım",
    },

    titles: {
      cncOperator: "CNC Operatörü",
      qualityEngineer: "KK Mühendisi",
      productionPlanning: "Üretim Planlama",
      maintenanceTechnician: "Bakım Teknisyeni",
      domesticSalesManager: "Yurt İçi Satış Müdürü",
      domesticSalesRepresentative: "Yurt İçi Satış Temsilcisi",
      domesticSalesSpecialist: "Yurt İçi Satış Uzmanı",
    },

    shifts: {
      day: "Gündüz",
      evening: "Akşam",
      night: "Gece",
    },

    // Shift Planning Localization RC1.6B2
    shiftsUi: {
      title: "Vardiya Planlama",
      subtitle: "Haftalık plan · Personel atama · Devam takibi",
      refresh: "Yenile",

      assignShiftTitle: "📅 Vardiya Ata",
      assignShift: "Vardiya Ata",
      saving: "Kaydediliyor...",
      saveError: "Vardiya kaydedilemedi.",
      personnelMachineRequired: "Personel ve makine zorunlu.",

      totalAssignments: "Toplam Atama",
      planned: "Planlanan",
      completed: "Tamamlanan",
      activePersonnel: "Aktif Personel",

      weeklyCalendar: "Haftalık Takvim",
      shiftList: "Vardiya Listesi",
      attendanceTracking: "Devam Takibi",

      previous: "Önceki",
      next: "Sonraki",
      today: "Bugün",

      personnel: "Personel",
      role: "Rol",
      machine: "Makine",
      shift: "Vardiya",
      date: "Tarih",
      checkIn: "Giriş",
      checkOut: "Çıkış",
      status: "Durum",
      action: "İşlem",
      workedHours: "Çalışma (sa)",
      overtime: "Fazla Mesai",

      noPersonnel: "Personel bulunamadı",
      noAssignments: "Vardiya ataması bulunamadı",
      noAttendance: "Devam kaydı bulunamadı",

      statusCompleted: "✓ Tamamlandı",
      statusPlanned: "⏳ Planlandı",
      delete: "Sil",
    },

    // HR Localization RC1.4C.2 — Employee Form
    // HR Localization RC1.4C.3 — Detail / List
    // HR Localization RC1.4D.1 — Attendance / Timesheet
    attendanceUi: {
      months: [
        "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
        "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
      ],
      viewTimesheet: "📊 Puantaj Görüntüle",
      addAttendance: "+ Devam Kaydı Ekle",
      markMissingAbsent: "⚠️ Kayıtsızları Devamsız İşaretle",
      selectMonthHint: "Yukarıdan ay seçip Puantaj Görüntüle butonuna tıklayın.",
      loading: "Yükleniyor...",
      personnel: "Personel",
      workDays: "İş Günü",
      hours: "Saat",
      overtime: "Fazla Mesai",
      date: "Tarih",
      checkInTime: "Giriş Saati",
      cancel: "İptal",
      checkOutTime: "Çıkış Saati",
      status: "Durum",
      save: "Kaydet",
      saving: "Kaydediliyor...",
      statusPresent: "Geldi",
      statusAbsent: "Devamsız",
      statusLate: "Geç",
      statusLeave: "İzinli",
      statusHoliday: "Tatil",
    },

    // HR Localization RC1.4E.1 — Payroll / AutoPayroll
    payrollUi: {
      months: [
        "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
        "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
      ],

      calculatePayroll: "🧮 Bordro Hesapla",
      savePayroll: "💾 Bordroyu Kaydet",
      saving: "Kaydediliyor...",
      calculating: "Hesaplanıyor...",
      selectMonthHint: "Ay seçip Bordro Hesapla butonuna tıklayın.",

      payrollInfo: "ℹ️ Bordro hesaplaması puantaj kayıtlarına dayanır. Önce Puantaj sekmesinden devam kayıtlarını girin.",
      payrollRatesInfo: "SGK oranları: İşçi %14, İşveren %20.75 | Damga Vergisi %0.759 | Fazla Mesai 1.5x (Çalışma Ayarları'ndan değiştirilebilir).",

      totalGross: "Toplam Brüt",
      totalNet: "Toplam Net",
      totalEmployerCost: "Toplam İşveren Maliyeti",
      totalEmployerSgk: "Toplam SGK İşveren",
      totalEmployeeSgk: "Toplam SGK İşçi",
      estimatedTotalNet: "Tahmini Toplam Net",

      personnel: "Personel",
      departmentShort: "Dept",
      workDays: "İş Günü",
      absent: "Devamsız",
      workHoursShort: "Çalışma Sa.",
      overtimeHoursShort: "Fazla M. Sa.",
      gross: "Brüt",
      absenceDeductionShort: "Devamsızlık Kes.",
      employeeSgk: "SGK İşçi",
      unemployment: "İşsizlik",
      incomeTaxShort: "Gelir V.",
      stampTaxShort: "Damga V.",
      net: "Net",
      employerSgk: "İşveren SGK",

      monthlyPayrollList: "💰 Aylık Bordro Listesi",
      estimatedCalculationNote: "*Tahmini hesaplama (%14 SGK, %15 gelir vergisi)",

      employee: "Çalışan",
      department: "Departman",
      grossSalary: "Brüt Maaş",
      employeeSgkRate: "SGK İşçi (%14)",
      incomeTaxRate: "Gelir Vergisi (%15)",
      netSalary: "Net Maaş",
      employerSgkRate: "SGK İşveren (%20.75)",

      disclaimer: "ℹ️ Bordro hesaplamaları tahminidir. Gerçek bordro için muhasebe departmanıyla koordinasyon gereklidir.",
      legislationNote: "SGK primleri ve vergi dilimleri mevzuata göre değişebilir.",
    },

    // HR Localization RC1.4F.1 — Competency / Training
    competencyUi: {
      intro: "🎯 Kim hangi makineyi / ekipmanı kullanabilir? Sertifika durumları ve yetki seviyeleri burada yönetilir.",
      employee: "Çalışan",
      noActiveEmployee: "Aktif çalışan bulunamadı",

      levels: {
        master: "Usta",
        basic: "Temel",
        trainee: "Stajyer",
        expired: "Süresi Doldu",
        none: "Yok",
      },

      levelDescriptions: {
        master: "Bağımsız çalışabilir, eğitim verebilir",
        basic: "Gözetim altında çalışabilir",
        trainee: "Eğitim sürecinde",
        expired: "Sertifika yenilenmeli",
        none: "Yetkisi bulunmuyor",
      },

      expiredDisplay: "⚠️ Süresi Doldu",

      skills: {
        cnc: "CNC Tezgah",
        lathe: "Torna",
        milling: "Freze",
        welding: "Kaynak",
        forklift: "Forklift",
        crane: "Vinç",
        press: "Pres",
        qualityEquipment: "Kalite Cihazları",
      },
    },

    trainingUi: {
      trainingUnit: "eğitim",
      completed: "Tamamlanan",
      expiredWarning: "⚠️ Süresi dolmuş sertifikalar var! İlgili çalışanları eğitime yönlendirin.",
      plannedTraining: "Planlanan Eğitim",
      participant: "Katılımcı",
      expiredCertificate: "Süresi Dolan Sertifika",

      planTitle: "📚 Eğitim Planı",
      addTraining: "+ Eğitim Ekle",

      categories: {
        safety: "İş Güvenliği",
        technical: "Teknik Eğitim",
        quality: "Kalite Eğitimi",
        machine: "Makine Kullanımı",
        management: "Yönetim Eğitimi",
        other: "Diğer",
      },

      emptyPlan: "📚 Eğitim planı henüz oluşturulmadı.",
      backendTrainingNote: "Backend'den /hr/trainings endpoint'i eklenince veriler burada görünecek.",

      certificateTracking: "🏆 Sertifika Takibi",
      employee: "Çalışan",
      department: "Departman",
      certificate: "Sertifika",
      issueDate: "Alınma Tarihi",
      validity: "Geçerlilik",
      status: "Durum",
      noCertificate: "Sertifika kaydı bulunamadı. /hr/certificates endpoint'i eklenince görünecek.",
    },

    // HR Localization RC1.4F.2 — Performance / Work Settings
    performanceUi: {
      overallScore: "Genel Puan",
      noActiveEmployee: "Aktif çalışan bulunamadı",
      evaluationCriteria: "📊 Değerlendirme Kriterleri",
      intro: "⭐ Çalışan performans değerlendirmesi — OEE verileriyle entegre, hedef takibi ve yıllık değerlendirme.",
      attendance: "Devam",
      productivity: "Üretkenlik",
      quality: "Kalite",

      criteria: {
        attendance: "Devam & Dakiklik",
        attendanceDesc: "İşe gelme oranı, geç kalma sayısı",
        productivity: "Üretkenlik",
        productivityDesc: "OEE verileri, hedef gerçekleşme oranı",
        quality: "Kalite",
        qualityDesc: "Hata oranı, yeniden işleme sayısı",
      },
    },

    orgChartUi: {
      title: "🏗️ Organizasyon Şeması",
      departmentDistribution: "📊 Departman Dağılımı",
    },

    workSettingsUi: {
      workHoursTitle: "🕐 Mesai Saatleri",
      workStart: "Mesai Başlangıç",
      workEnd: "Mesai Bitiş",
      normalWorkPrefix: "ℹ️ Normal mesai:",
      normalWorkBetween: ".",
      total: "Toplam:",
      hourUnit: "saat.",

      breakSettings: "☕ Mola Ayarları",
      lunchBreak: "Öğle Yemeği Molası (dakika)",
      teaBreak: "Çay/Kısa Mola Toplam (dakika)",
      totalBreak: "⚠️ Toplam mola:",
      minuteUnit: "dakika.",
      breakDeductionInfo: "Net çalışma saati hesaplanırken bu süreler düşülür.",

      overtimeSettings: "⏰ Fazla Mesai & Hafta Sonu Çarpanları",
      overtimeMultiplier: "Fazla Mesai Çarpanı",
      overtimeMultiplierDesc: "Normal ücretin kaç katı?",
      saturdayMultiplier: "Cumartesi Çarpanı",
      saturdayMultiplierDesc: "Cumartesi çalışma çarpanı",
      sundayMultiplier: "Pazar Çarpanı",
      sundayMultiplierDesc: "Pazar çalışma çarpanı",

      workDaysLeave: "📅 Çalışma Günleri & İzin",
      workDays: "Çalışma Günleri",
      annualLeaveDays: "Yıllık İzin Hakkı (gün)",

      days: {
        Mon: "Pzt",
        Tue: "Sal",
        Wed: "Çar",
        Thu: "Per",
        Fri: "Cum",
        Sat: "Cmt",
        Sun: "Paz",
      },

      saved: "✅ Ayarlar kaydedildi!",
      saving: "Kaydediliyor...",
      save: "💾 Ayarları Kaydet",
    },

    // HR Localization RC1.4G — Final visible polish
    finalUi: {
      personalInfo: "👤 Kişisel Bilgiler",
      emergencyContact: "Acil İletişim",
      workInfo: "💼 İş Bilgileri",
      role: "Rol",
      hireDate: "İşe Başlama",
      seniorityYears: "Kıdem (Yıl)",
      notes: "Notlar",
      select: "Seçin...",

      shortAttendance: {
        present: "G",
        absent: "D",
        late: "Geç",
        leave: "İ",
        holiday: "T",
      },
    },

    employeeDetail: {
      birthDate: "Doğum Tarihi",
      phone: "Telefon",
      email: "E-posta",
      employeeNo: "Sicil No",
      department: "Departman",
      position: "Pozisyon",
      shift: "Vardiya",
      manager: "Yönetici",

      last30DaysSummary: "📊 Son 30 Gün Özeti",
      last30Days: "Son 30 Gün",
      attendance: "Devam",
      day: "Gün",
      late: "Geç",
      absent: "Devamsız",

      date: "Tarih",
      checkIn: "Giriş",
      checkOut: "Çıkış",
      workingHours: "Çalışma Saati",
      status: "Durum",
      noAttendance: "Devam kaydı bulunamadı",

      annualLeaveAllowance: "Yıllık İzin Hakkı",
      usedLeave: "Kullanılan",
      dayUnit: "gün",
      noLeave: "İzin kaydı bulunamadı",

      leaveApproved: "Onaylandı",
      leavePending: "Bekliyor",
      leaveRejected: "Reddedildi",

      noPayslip: "Bordro kaydı bulunamadı",
      payslipSuffix: "Bordrosu",
      grossSalary: "Brüt Maaş",
      socialSecurityEmployee: "SGK İşçi",
      netSalary: "Net Maaş",

      seniority: "Kıdem",
      yearShort: "y",

      employee: "Çalışan",
      hireDate: "İşe Başlama",
      action: "İşlem",
      noEmployee: "Çalışan bulunamadı",

      todayAttendance: "📋 Bugünkü Devam Durumu",
    },

    employeeForm: {
      addTitle: "➕ Yeni Çalışan",
      editTitle: "✏️ Çalışan Düzenle",
      department: "Departman",
      positionTitle: "Pozisyon / Unvan",
      role: "Rol",
      status: "Durum",
      shift: "Vardiya",
      hireDate: "İşe Başlama Tarihi",
      birthDate: "Doğum Tarihi",
      grossSalary: "Brüt Maaş (₺)",
      annualLeaveDays: "Yıllık İzin (gün)",
      manager: "Yönetici",
      emergencyContact: "Acil İletişim",
      cancel: "İptal",
      saving: "Kaydediliyor...",
      update: "Güncelle",
      add: "Ekle",
      employeeLoadFailed: "Çalışan verileri alınamadı",
      fullName: "Ad Soyad *",
      employeeNo: "Sicil No",
      nationalId: "TC Kimlik No",
      email: "E-posta",
      phone: "Telefon",
      address: "Adres",
      requiredNameDepartment: "Ad soyad ve departman zorunlu.",
      genericError: "Hata",
    },
  },

  // Kaizen
  kaizen: {
    title: "Kaizen & İyileştirme",
    suggestion: "Öneri",
    problem: "Problem",
    solution: "Çözüm",
    estimatedSaving: "Tahmini Tasarruf",
    actualSaving: "Gerçekleşen Tasarruf",
    status: {
      idea: "Fikir",
      reviewing: "İnceleniyor",
      implementing: "Uygulanıyor",
      completed: "Tamamlandı",
      rejected: "Reddedildi",
    },
  },

  // Raporlar
  reports: {
    title: "Raporlar",
    production: "Üretim Raporu",
    quality: "Kalite Raporu",
    maintenance: "Bakım Raporu",
    energy: "Enerji Raporu",
    stock: "Stok Raporu",
    financial: "Finansal Rapor",
    hr: "İK Raporu",
    kaizen: "Kaizen Raporu",
    startDate: "Başlangıç Tarihi",
    endDate: "Bitiş Tarihi",
    download: "📥 PDF İndir",
    generate: "Rapor Oluştur",

    // Reports Localization RC1
    tabDashboard: "📊 Yönetim Paneli",
    tabScrap: "🔥 Fire Raporu",

    // Reports Localization RC1.1C - Fire Report
    fireAnalysisTitle: "🔥 Fire / Hurda Analizi",
    fireAnalysisDesc: "Son 30 günlük fire kayıtları",
    fireRefresh: "🔄 Yenile",
    fireLoading: "Yükleniyor...",
    fireLoadFailed: "Veri alınamadı",

    fireAvgRate: "Ortalama Fire Oranı",
    fireTotalFailed: "Toplam Fire Adedi",
    fireTotalProduced: "Toplam Üretilen",
    fireAffectedProducts: "Etkilenen Ürün",
    fireUnitPieces: "adet",
    fireUnitTypes: "çeşit",

    fireTabOverview: "📊 Özet",
    fireTabRecords: "📋 Kayıtlar",
    fireTabTrend: "📈 Trend",

    fireByProduct: "📦 Ürün Bazlı Fire Oranı",
    fireByCustomer: "👤 Müşteri Bazlı Fire",

    fireColProductCode: "Ürün Kodu",
    fireColProductName: "Ürün Adı",
    fireColProduct: "Ürün",
    fireColCustomer: "Müşteri",
    fireColPlanned: "Planlanan",
    fireColScrap: "Fire",
    fireColRate: "Oran",

    fireNoData: "Veri yok",
    numberLocale: "tr-TR",

    // Reports Localization RC1.1D
    fireDailyQty: "📈 Günlük Fire Adedi",
    fireDailyRate: "📉 Günlük Fire Oranı %",
    fireQty: "Fire Adedi",
    fireRateLabel: "Fire Oranı",
    firePercent: "Fire %",

    selectReportHint: "💡 Rapor oluşturmak için bir rapor türü seçin.",
    view: "Görüntüle",

    reportCreateFailed: "Rapor oluşturulamadı",
    startDateLabel: "Başlangıç Tarihi",
    endDateLabel: "Bitiş Tarihi",

    customerType: "Müşteri Tipi",
    customerAll: "🌍 Tümü",
    customerDomestic: "🏠 Yurt İçi",
    customerForeign: "✈️ Yurt Dışı",

    reportScope: "Rapor Kapsamı",
    scopeAllPersonnel: "👥 Tüm Personel",
    scopeDepartment: "🏢 Departman",
    scopeSinglePersonnel: "👤 Tek Personel",

    department: "Departman",
    employeeName: "Personel Adı",
    selectDepartment: "— Departman seçin —",
    employeePlaceholder: "Personel adı yazın...",
    selected: "✓ Seçildi",

    outputFormat: "Çıktı Formatı",
    includeCharts: "📈 Grafikleri dahil et",
    includeDetails: "📋 Detay tabloları dahil et",
    sendEmail: "📧 E-posta ile gönder",
    emailAddress: "E-posta Adresi",

    cancel: "İptal",
    generating: "Oluşturuluyor...",
    generateReport: "Raporu Oluştur",

    // Report Types RC1.1D
    reportTypeProduction: "Üretim Raporu",
    reportTypeProductionDesc: "OEE, üretim miktarı, makine performansı",
    reportTypeQuality: "Kalite Raporu",
    reportTypeQualityDesc: "Geçiş oranı, hurda, kalite trendleri",
    reportTypeFire: "Fire / Hurda Raporu",
    reportTypeFireDesc: "Fire kayıtları, ürün bazlı hurda oranı, maliyet",
    reportTypeMaintenance: "Bakım Raporu",
    reportTypeMaintenanceDesc: "MTBF, MTTR, bakım maliyetleri",
    reportTypeEnergy: "Enerji Raporu",
    reportTypeEnergyDesc: "Tüketim, maliyet, CO₂ emisyonu",
    reportTypeStock: "Stok Raporu",
    reportTypeStockDesc: "Stok hareketleri, kritik seviyeler, değer",
    reportTypeFinancial: "Finansal Özet",
    reportTypeFinancialDesc: "Gelir, gider, üretim maliyeti özeti",
    reportTypeHr: "İK Raporu",
    reportTypeHrDesc: "Devam, izin, bordro özeti",
    reportTypeKaizen: "Kaizen Raporu",
    reportTypeKaizenDesc: "İyileştirme önerileri, tasarruf, 5S",
    reportTypeNcr: "NCR & CAPA Raporu",
    reportTypeNcrDesc: "NCR sayısı, maliyet, karar dağılımı, CAPA özeti",
    reportTypeSales: "Satış Siparişleri Raporu",
    reportTypeSalesDesc: "Sipariş durumu, sevkiyat özeti, müşteri bazlı analiz",
    reportTypeSalesPersonnel: "Satış Personeli Raporu",
    reportTypeSalesPersonnelDesc: "Personel bazlı ciro, yurt içi/dışı karşılaştırma, dönem analizi",
    reportTypePersonnelAll: "Personel & İK Raporu",
    reportTypePersonnelAllDesc: "Tüm departmanlar, mesai, devam, bordro özeti",
    // PersonnelReport Localization RC1.1F
    personnelReportTotalPersonnel: "Toplam Personel",
    personnelReportActivePersonnel: "Aktif Personel",
    personnelReportTotalAbsence: "Toplam Devamsızlık",
    personnelReportTotalOvertime: "Toplam Mesai",
    personnelReportAllSuffix: "Tümü",
    personnelReportPersonUnit: "kişi",
    personnelReportSearchPlaceholder: "🔍 Personel ara...",
    personnelReportAllDepartments: "🏢 Tüm Departmanlar",
    personnelReportListTitle: "👥 Personel Listesi",
    personnelReportDetailHint: "Bireysel PDF/Excel için 👤 Detay butonuna tıklayın",
    personnelReportNotFound: "Personel bulunamadı",
    personnelReportColumnPersonnel: "Personel",
    personnelReportColumnDepartment: "Departman",
    personnelReportColumnTitle: "Ünvan",
    personnelReportColumnStatus: "Statü",
    personnelReportColumnHireDate: "İşe Giriş",
    personnelReportColumnShift: "Vardiya",
    personnelReportActive: "✅ Aktif",
    personnelReportPassive: "⏸ Pasif",
    personnelReportDetail: "👤 Detay",
    personnelReportLoading: "Veriler yükleniyor...",
    personnelReportTotalWork: "Toplam Çalışma",
    personnelReportAbsence: "Devamsızlık",
    personnelReportLeaveDays: "İzin Günü",
    personnelReportOvertimeHours: "Mesai (Saat)",
    personnelReportGrossSalary: "Brüt Maaş",
    personnelReportNetSalary: "Net Maaş",
    personnelReportDayUnit: "gün",
    personnelReportHourUnit: "sa",
    personnelReportPayrollBreakdown: "💰 Bordro Dökümü",
    personnelReportSgkEmployee: "SGK İşçi (%14)",
    personnelReportIncomeTax: "Gelir Vergisi",
    personnelReportStampTax: "Damga Vergisi",
    personnelReportUnemploymentInsurance: "İşsizlik Sig.",
    personnelReportAttendanceTitle: "📅 Devam Kayıtları (Son 10)",
    personnelReportDate: "Tarih",
    personnelReportCheckIn: "Giriş",
    personnelReportCheckOut: "Çıkış",
    personnelReportAttendanceStatus: "Durum",
    personnelReportOvertime: "Mesai",
    personnelReportPresent: "✅ Geldi",
    personnelReportAbsent: "❌ Gelmedi",
    personnelReportLeave: "🌴 İzin",
    personnelReportNoDetail: "Bu personel için detay verisi bulunamadı.",

    // Reports Final Localization RC1.1G
    reportsGenerationFailed: "Rapor oluşturulamadı",
    reportsDataNotFound: "Veri bulunamadı",
    reportsDataLoadFailed: "Veri alınamadı",
    plPendingScrapDecision: "Bekleyen Fire Kararı",
    plPendingScrapMessage: "{amount} tutarında fire için NCR kararı bekleniyor.",
    plSalesRevenue: "Satış Geliri",
    plSalesSplit30: "🌍 Satış Ayrımı — Son 30 Gün",
    plDomesticSales: "🏠 Yurt İçi Satış",
    plForeignSales: "✈️ Yurt Dışı Satış",
    plGrandTotal: "📊 Genel Toplam",
    plOrderUnit: "sipariş",
    plCustomerUnit: "müşteri",
    plPieceUnit: "adet",
    plTotalOrderUnit: "toplam sipariş",
    plTotalCustomerUnit: "toplam müşteri",
    plTotalPieceUnit: "toplam adet",
    plRevenueShare: "Toplam cirodaki payı",
    plDomesticLegend: "Yurt İçi",
    plForeignLegend: "Yurt Dışı",
    plScrapRevenue: "Hurda Geliri",
    plProductionCost: "Üretim Maliyeti",
    plScrapLoss: "Fire Kaybı",
    plPendingScrap: "Hurda Bekleyen",
    plNetProfitLoss30: "NET KAR / ZARAR (Son 30 Gün)",
    plProductAnalysis: "📦 Ürün Bazlı Analiz",
    plColumnProduct: "Ürün",
    plColumnShippedQty: "Sevk Adet",
    plColumnConfirmedScrap: "Fire (Kesin)",
    plColumnPendingScrap: "Fire (Bekleyen)",
    plColumnScrap: "Hurda",
    plColumnNet: "Net",
    fireRecent20Title: "📋 Son 20 Fire Kaydı",
    fireNoRecords: "Kayıt yok",
    fireColWorkOrder: "İş Emri",
    fireColOrder: "Sipariş",
    fireColPassed: "Geçen",
    fireColDate: "Tarih",
    fireColCreatedBy: "Oluşturan",
    summaryFire30Title: "🔥 Fire Özeti (Son 30 Gün)",
    summaryNoFire: "Fire kaydı bulunamadı ✅",
    summaryDetailButton: "Detaylar →",
    summaryScrapUnit: "fire",
    historyTitle: "📋 Rapor Geçmişi",
    historyReportType: "Rapor Türü",
    historyFormat: "Format",
    historyDateRange: "Tarih Aralığı",
    historyCreatedBy: "Oluşturan",
    historyDate: "Tarih",
    historyDownload: "İndir",
    historyEmpty: "Rapor geçmişi bulunamadı",
    historyDownloadButton: "⬇ İndir",

    // Variance Analysis Localization RC1.1H
    varianceFilters: "🔍 Filtreler",
    varianceAnalyze: "🔍 Analiz Et",
    varianceStartDate: "Başlangıç Tarihi",
    varianceEndDate: "Bitiş Tarihi",
    varianceProductCodeOptional: "Ürün Kodu (opsiyonel)",
    varianceAll: "Tümü",
    varianceLoading: "Yükleniyor...",
    varianceTotalWorkOrders: "Toplam İş Emri",
    varianceSavingProvided: "Tasarruf Sağlanan",
    varianceBudgetOverrun: "Bütçe Aşımı",
    varianceSaving: "Tasarruf",
    varianceOverrun: "Aşım",
    varianceNeutral: "Nötr",
    varianceNoData: "Veri yok",
    varianceOrderNo: "Sipariş No",
    varianceProductCode: "Ürün Kodu",
    varianceProduct: "Ürün",
    varianceQuantity: "Miktar",
    varianceStandardCost: "Standart Maliyet",
    varianceActualCost: "Fiili Maliyet",
    varianceTotalVariance: "Toplam Varyans",
    varianceNotEntered: "Girilmedi",
    varianceStandard: "Standart",
    varianceActual: "Fiili",
    varianceValue: "Varyans",
    variancePercent: "Varyans %",
    varianceStatus: "Durum",
    varianceWorkOrderUnit: "iş emri",
    varianceNoActualCostOrders: "Bu dönemde fiili maliyet girilmiş iş emri bulunamadı.",
    varianceWorkOrderDetail: "İş Emri Bazlı Varyans Detayı",
    tabQualityPnl: "💹 Kalite & Fire P&L",
    tabSalesPerformance: "💼 Satış Performansı",
    tabPersonnelReports: "👥 Personel Raporları",
    tabGenerateReport: "📄 Rapor Oluştur",
    tabHistory: "📋 Geçmiş",
    tabVarianceAnalysis: "📉 Varyans Analizi",

    // Reports Sales Performance RC1.1E
    salesPerfLoading: "Yükleniyor...",
    salesPerfNoData: "Veri bulunamadı",
    salesPerfTitle: "💼 Satış Performansı",

    salesPeriodMonth: "Bu Ay",
    salesPeriodQuarter: "3 Ay",
    salesPeriodHalfYear: "6 Ay",
    salesPeriodYear: "Bu Yıl",

    salesTotalOrders: "Toplam Sipariş",
    salesTotalRevenue: "Toplam Ciro",
    salesPersonnel: "Satış Personeli",
    salesActiveCustomers: "Aktif Müşteri",

    salesUnitOrders: "adet",
    salesUnitPieces: "adet",
    salesUnitPersonnel: "kişi",
    salesUnitCustomers: "müşteri",

    salesDomestic: "Yurt İçi",
    salesForeign: "Yurt Dışı",
    salesAll: "Tümü",
    salesDomesticTitle: "🏠 Yurt İçi Satış",
    salesForeignTitle: "✈️ Yurt Dışı Satış",

    salesPersonnelDetail: "👤 Tüm Personel Performans Detayı",

    salesColPersonnel: "Personel",
    salesColRegion: "Bölge",
    salesColLevel: "Seviye",
    salesColOrders: "Sipariş",
    salesColCompleted: "Tamamlanan",
    salesColRevenue: "Toplam Ciro",
    salesColAvgOrder: "Ort. Sipariş Değeri",
    salesColCustomer: "Müşteri",
    salesColTarget: "Hedef Gerçekleşme",
    salesColDetail: "Detay",

    salesColProductCode: "Ürün Kodu",
    salesColProductName: "Ürün Adı",
    salesColOrderCount: "Sipariş Sayısı",
    salesColTotalQty: "Toplam Adet",

    salesDomesticTotal: "Yurt İçi Toplam",
    salesForeignTotal: "Yurt Dışı Toplam",

    salesRecentOrders: "Son Siparişler",
    salesOrderNo: "Sipariş No",
    salesAmount: "Tutar",
    salesStatus: "Durum",
    salesStatusShipped: "Sevk Edildi",
    salesStatusPartialShipped: "Kısmi Sevkiyat",
    salesStatusCompleted: "Tamamlandı",
    salesDate: "Tarih",

    // Sales Performance Final Polish RC1.1E
    salesOrderLabel: "Sipariş",
    salesCustomerLabel: "Müşteri",
    salesPersonnelLabel: "Personel",
    salesOrderSuffix: "sipariş",
    salesTarget: "Hedef",
    salesDetail: "Detay",

    salesLevelDirector: "Direktör",
    salesLevelManager: "Müdür",
    salesLevelChief: "Şef",
    salesLevelRep: "Personel",
    salesNoTarget: "Hedef yok",
    salesTopProducts: "📦 En Çok Satan Ürünler",
    salesGrandTotal: "Genel Toplam",
    // Reports Management Dashboard RC1.1A
    subtitle: "Fabrika özeti · PDF/Excel dışa aktarım · Fire & Hurda analizi",
    refresh: "Yenile",
    loading: "Veriler yükleniyor...",
    factoryOee: "Fabrika OEE",
    totalProduction: "Toplam Üretim",
    qualityRate: "Kalite Oranı",
    energyCost: "Enerji Maliyeti",
    maintenanceCost: "Bakım Maliyeti",
    stockValue: "Stok Değeri",
    activeEmployees: "Aktif Çalışan",
    scrapRate30d: "Fire Oranı (30g)",
    unitPieces: "adet",
    unitPeople: "kişi",
    productionOeeTrend30d: "30 Günlük Üretim & OEE Trendi",
    productionLegend: "Üretim",
    noProductionData: "Üretim verisi bulunamadı",
    machineStatusDistribution: "Makine Durum Dağılımı",
    noMachineData: "Makine verisi yok",

    // Reports Management Dashboard RC1.1B
    qualityRateTrend: "Kalite Oranı Trendi",
    qualityPassLegend: "Geçiş %",
    qualityFailLegend: "Başarısız %",
    costTrend: "Maliyet Trendi",
    noData: "Veri yok",
    maintenanceLegend: "Bakım",
    energyLegend: "Enerji",
    productionCostLegend: "Üretim",
    machineStatus: {
      offline: "Çevrimdışı",
      running: "Çalışıyor",
      fault: "Arıza",
      idle: "Boşta",
      active: "Aktif",
    },
  },

  // Login
  login: {
    title: "Giriş Yap",
    username: "Kullanıcı Adı",
    password: "Şifre",
    submit: "🔐 Giriş Yap",
    error: "Kullanıcı adı veya şifre hatalı",
    locked: "Hesap kilitli. Lütfen bekleyin.",
    loggingIn: "Giriş yapılıyor...",
    system: "Opement Smart Factory System MES · Operatör Ekranı",
  },

  // Satın Alma
  purchasing: {
    title: "Satın Alma Talepleri",
    requestNo: "Talep No",
    material: "Malzeme",
    needed: "Gereken",
    available: "Mevcut",
    requested: "Talep Edilen",
    requestedBy: "Talep Eden",
    status: {
      pending: "Bekliyor",
      approved: "Onaylandı",
      rejected: "Reddedildi",
      ordered: "Sipariş Verildi",
      received: "Teslim Alındı",
    },
  

      newRequest: "Yeni Satın Alma Talebi",
      materialName: "Malzeme Adı",
      materialNamePlaceholder: "Malzeme adını yazın...",
      materialCode: "Malzeme Kodu",
      workOrder: "İş Emri",
      workOrderNo: "İş Emri No",
      workOrderPlaceholder: "Hangi iş emri için?",
      requestQuantity: "Talep Miktarı",
      priority: "Öncelik",
      supplier: "Tedarikçi",
      selectSupplierOptional: "Tedarikçi seçin (opsiyonel)",
      selectSupplier: "Tedarikçi seçin...",
      loading: "Yükleniyor...",
      cancel: "İptal",
      save: "Kaydet",
      create: "Oluştur",
      update: "Güncelle",
      requiredMaterialQuantity: "Malzeme adı ve talep miktarı zorunlu.",
      requiredReceivedGood: "Teslim alınan miktar ve sağlam miktar zorunlu.",
      genericError: "İşlem başarısız.",

      incomingQcTitle: "Hammadde Giriş Kalite Kontrol",
      supplierLabel: "Tedarikçi",
      orderQuantity: "Sipariş Miktarı",
      receivedQuantity: "Teslim Alınan Miktar",
      goodQuantity: "Sağlam Miktar",
      brokenQuantity: "Kırık Miktar",
      damagedQuantity: "Hasarlı/Ezik Miktar",
      qualityRate: "Kalite Oranı",
      good: "Sağlam",
      broken: "Kırık",
      damaged: "Hasarlı",

      qcApprovalTitle: "KK Sonucu Onayı",
      approvalNotes: "Onay Notları",
      approvalNotesPlaceholder: "Onay veya ret gerekçenizi yazın...",
      lowQualityWarning: "Kalite oranı %80'in altında! Reddetmeniz önerilir.",
      approveAddStock: "Onayla — Stoka Ekle",
      approve: "Onayla",
      reject: "Reddet",

      requestDetails: "Talep Detayları",
      approvedBy: "Onaylayan",

      tabRequests: "Satın Alma Talepleri",
      tabIncomingQc: "Giriş KK",
      tabQcApproval: "KK Onayı",
      pageTitle: "Satın Alma & Giriş KK",
      pageSubtitle: "Malzeme talepleri · Tedarikçi siparişleri · Hammadde giriş kalite kontrol",
      newRequestButton: "Yeni Talep",
      deliveryWaitingMessage: "{count} adet sipariş teslimat bekliyor. Giriş KK yapmak için tıklayın →",
      qcApprovalWaitingMessage: "{count} adet KK sonucu onayınızı bekliyor →",

      totalRequests: "Toplam Talep",
      ordered: "Sipariş Verildi",
      received: "Teslim Alındı",

      searchPlaceholder: "Malzeme, talep no veya iş emri ara...",
      allStatuses: "Tüm Durumlar",
      allPriorities: "Tüm Öncelikler",
      request: "Talep",
      unit: "Birim",
      stockLabel: "Stok",
      date: "Tarih",
      statusLabel: "Durum",
      action: "İşlem",
      noRequests: "Henüz satın alma talebi yok.",
      noMatchingRequests: "Eşleşen talep bulunamadı.",

      noPendingDelivery: "Teslimat bekleyen sipariş yok",
      doIncomingQc: "Giriş KK Yap",
      qcHistory: "Geçmiş KK Kayıtları",
      orderNo: "Sipariş No",
      expected: "Beklenen",
      delivered: "Teslim",
      checkedBy: "Kontrol Eden",
      qualityPercent: "Kalite %",
      noPendingQcApproval: "Onay bekleyen KK kaydı yok",
      lowQuality: "Düşük Kalite",
      reviewApprove: "İncele & Onayla",
      approvedStocked: "Onaylanmış & Stoka Eklenen",
      urgentRequestsWaiting: "{count} adet acil talep bekliyor!",
      addedToStock: "{count} adet stoka eklendi",

      priorityLow: "Düşük",
      priorityNormal: "Normal",
      priorityHigh: "Yüksek",
      priorityUrgent: "Acil",
      statusPending: "Bekliyor",
      statusApproved: "Onaylandı",
      statusOrdered: "Sipariş Verildi",
      statusReceived: "Teslim Alındı",
      statusChecked: "KK Yapıldı",
      statusRejected: "Reddedildi",
      statusCancelled: "İptal",
      creatingRequest: "Kaydediliyor...",
      createRequest: "Talebi Oluştur",
      defective: "Hatalı",
      checkNotes: "Kontrol Notları",
      checkNotesPlaceholder: "Gözlemlerinizi yazın...",
      warehouseQcResults: "Depocu KK Sonuçları",
      connectionError: "Bağlantı hatası",
      orderCount: "sipariş",

      neededQuantity: "Gereken Miktar",
      availableQuantity: "Mevcut Miktar",
      unitPrice: "Birim Fiyat",
      notes: "Notlar",
      missingQuantity: "Eksik Miktar",
      qcWaiting: "KK Bekleyen",

      expectedQuantity: "Beklenen",
      missing: "Eksik",

      lastPrice: "Son fiyat",
},

  // Kiosk
  kiosk: {
    panel: "Operatör Paneli",
    myOrders: "İş Emirlerim",
    noOrders: "Atanmış iş emriniz yok",
    noOrdersDesc: "Üretim müdürünüzle iletişime geçin",
    start: "▶ Üretime Başla",
    pause: "⏸ Duraklat",
    complete: "✅ Tamamla",
    reportProblem: "🚨 Sorun Bildir",
    productionProgress: "📊 Üretim İlerlemesi",
    orderInfo: "📋 İş Emri Bilgileri",
    bom: "📋 Ürün Reçetesi",
    inProgress: "▶ Üretim Devam Ediyor",
    clickForDetail: "👆 Detay ve İşlemler için tıklayın",
  },

  machines: {
    title: "Makine Yönetimi",
    subtitle: "Canlı izleme · OEE takibi · Arıza geçmişi · Makine ekleme",
    addMachine: "Makine Ekle",
    editMachine: "Makine Düzenle",
    refresh: "Yenile",
    detail: "Detay",
    edit: "Düzenle",
    cancel: "İptal",
    save: "Kaydet",
    update: "Güncelle",
    add: "Ekle",
    saving: "Kaydediliyor...",
    loading: "Yükleniyor...",
    noMachines: "Makine bulunamadı",
    machineCount: "makine",
    allStatuses: "Tüm Durumlar",
    searchPlaceholder: "Makine adı veya ID ara...",
    actions: "İşlem",
    // Form alanları
    machineId: "Makine ID",
    machineName: "Makine Adı",
    machineType: "Tür",
    location: "Konum",
    brand: "Marka",
    model: "Model",
    serialNo: "Seri No",
    statusLabel: "Durum",
    notes: "Notlar",
    // Hata
    errIdNameRequired: "Makine ID ve adı zorunlu.",
    errGeneric: "Hata",
    // Durum etiketleri
    statusRunning: "Çalışıyor",
    statusStopped: "Durdu",
    statusFault: "Arıza",
    statusMaintenance: "Bakımda",
    statusIdle: "Bekliyor",
    // Detay sekmeleri
    tabOverview: "Canlı SCADA",
    tabMachineInfo: "Makine Bilgileri",
    tabOee: "OEE & Performans",
    tabFaults: "Arıza Geçmişi",
    tabMaintenance: "Bakım Takvimi",
    tabAlarms: "Alarm Geçmişi",
    tabParts: "Yedek Parçalar",
    tabStatusLog: "Durum Günlüğü",

    // Canlı SCADA
    noDataReceived: "Veri alınmadı",
    now: "Şimdi",
    secondsAgo: "sn önce",
    minutesAgo: "dk önce",
    hoursAgo: "sa önce",
    lastData: "SON VERİ",
    spindleSpeed: "SPINDLE DEVRİ",
    feedProgress: "İLERLEME",
    last60Measurements: "SON 60 ÖLÇÜM",
    waitingForLiveData: "CANLI VERİ BEKLENİYOR",
    productionUpper: "ÜRETİM",
    cycleUpper: "ÇEVRİM",
    scrapUpper: "FİRE",
    pcsUnit: "adet",

    machineUnreachable: "Makineye ulaşılamıyor",
    telemetryDisconnected: "Canlı telemetri kesildi. Son alınan veri:",
    activeFanucAlarm: "AKTİF FANUC ALARMI",
    connectionActiveNoAlarm: "Makine bağlantısı aktif — alarm bulunmuyor",

    activeWorkOrder: "Aktif İş Emri",
    product: "Ürün",
    operator: "Operatör",
    productionQuality: "Üretim & Kalite",
    produced: "Üretilen",
    reworkRequired: "Yeniden üretilmesi gereken:",
    noActiveWorkOrder: "Aktif iş emri bulunmuyor",
    workOrderDataHint: "Üretim ve kalite değerleri iş emri başlatıldığında burada gösterilecek.",

    cncProgram: "CNC Programı",
    programName: "Program Adı",
    tool: "Takım",
    lineBlock: "Satır / Blok",

    liveOee: "Canlı OEE",
    statusTimeline: "Durum Zaman Çizgisi",
    feedRate: "İlerleme (Feed)",
    program: "Program",
    partCount: "Parça Sayısı",
    alarm: "Alarm",
    none: "Yok",
    lastSeen: "Son Veri",
    connection: "Bağlantı",
    driver: "Driver",

    // Canlı zaman / OEE / durum açıklamaları
    quality: "Kalite",
    oee7days: "7 Günlük OEE Trendi",
    dataUnavailable: "Veri alınmadı",
    connectionLost: "Bağlantı Yok",
    waitingWorkOrder: "İş Emri Bekleniyor",
    machineAlarmReason: "Makine alarm verdi. Alarm kodu:",
    machineAlarmTransition: "Makine alarm durumuna geçti.",
    machineTelemetryLostReason: "Makineden telemetri bağlantısı kesildi.",
    machineMovementResumed: "Makine hareketi yeniden başladı.",
    statusReasonUnavailable: "Bu durum değişikliği için ayrıntılı neden kaydedilmemiş.",
    machineStoppedReason: "Makine durdu.",
    machineRunningReason: "Makine çalışmaya başladı.",
    // Genel sekmesi
    machineInfo: "Makine Bilgileri",
    productionInfo: "Üretim Bilgileri",
    temperature: "Sıcaklık",
    production: "Üretim",
    defective: "Fire",
    shift: "Vardiya",
    lastUpdate: "Son Güncelleme",
    defectRate: "Fire Oranı",
    purchaseDate: "Satın Alma",
    warrantyEnd: "Garanti Bitiş",
    // OEE sekmesi
    oee14days: "14 Günlük OEE Trendi",
    noOeeHistory: "OEE geçmişi bulunamadı",
    availability: "Kullanılabilirlik %",
    performance: "Performans %",
    // Arıza sekmesi
    noFaults: "Arıza kaydı bulunamadı",
    faultType: "Arıza Tipi",
    description: "Açıklama",
    durationMin: "Süre (dk)",
    date: "Tarih",
    // Yedek parça sekmesi
    noParts: "Yedek parça kaydı bulunamadı",
    partName: "Parça Adı",
    category: "Kategori",
    unit: "Birim",
    stock: "Stok",
    minStock: "Min. Stok",
    critical: "Kritik",
    sufficient: "Yeterli",
    // İstatistikler
    totalMachines: "Toplam Makine",
    running: "Çalışıyor",
    fault: "Arıza",
    avgOee: "Ort. OEE",
    machine: "Makine",
  },

  machinesx: {
    livePower: "Anlık Güç",
    machinePartCounter: "Makine Parça Sayacı",
    todayProduced: "Bugün Üretilen",
    shiftTarget: "Vardiya Hedefi",
    shiftScrap: "Vardiya Fire",
    workOrderTarget: "İş Emri Hedefi",
    totalProduced: "Toplam Üretilen",
    workOrderScrap: "İş Emri Fire",
    workOrderRemaining: "İş Emri Kalanı",
    title: "Makine Yönetimi",
    subtitle: "Gerçek zamanlı izleme · OEE analizi · Bakım takibi",
    addMachine: "Makine Ekle",
    editMachine: "Makine Düzenle",
    refresh: "Yenile",
    detail: "Detay",
    edit: "Düzenle",
    close: "Kapat",
    cancel: "İptal",
    update: "Güncelle",
    add: "Ekle",
    saving: "Kaydediliyor...",
    loading: "Yükleniyor...",
    loadingMachines: "Makineler yükleniyor...",
    noMachinesYet: "Henüz makine kaydı yok.",
    noMatch: "Filtrelerle eşleşen makine bulunamadı.",
    noMachines: "Makine bulunamadı",
    machineShowing: "makine gösteriliyor",
    allStatuses: "Tüm Durumlar",
    allTypes: "Tüm Türler",
    searchPlaceholder: "Makine adı veya ID ara...",
    actions: "İşlem",
    retry: "Tekrar Dene",
    // Durum etiketleri
    statusRunning: "Çalışıyor",
    statusIdle: "Boşta",
    statusMaintenance: "Bakım",

    statusStale: "Veri Gecikiyor",
    statusAlarm: "Alarm",
    statusSetup: "Kurulum",
    statusToolChange: "Takım Değişimi",
    statusUnknown: "Bilinmiyor",

    productionRunning: "Üretim Devam Ediyor",
    productionPaused: "Üretim Duraklatıldı",
    productionCompleted: "Üretim Tamamlandı",

    errSaveMachine: "Makine kaydedilemedi",

    durationLabel: "Süre",
    costLabel: "Maliyet",
    hoursShort: "saat",
    resolvedClosed: "Çözüldü / Kapandı",
    completedLabel: "Tamamlandı",
    criticalUpper: "KRİTİK",
    infoUpper: "BİLGİ",
    minimumStockUpper: "MİNİMUM STOK",
    supplierLabel: "Tedarikçi",
    operatorLabel: "Operatör",

    // RC1.1D — final UI labels
    warningUpper: "UYARI",
    pendingLabel: "Bekliyor",
    inProgressLabel: "Devam Ediyor",
    maintenanceCompletionLabel: "Tamamlanma",
    eventDateLabel: "Tarih",
    minimumLabel: "Minimum",
    unitPriceLabel: "Birim Fiyat",
    codeLabel: "Kod",
    minutesShort: "dk",

    filterRunning: "Çalışıyor",
    filterIdle: "Bekleme",
    filterFault: "Alarm",
    filterStopped: "Durdu",
    statusFault: "Arıza",
    statusStopped: "Durduruldu",
    // Form alanları
    machineName: "Makine Adı",
    machineId: "Makine ID",
    machineType: "Tür",
    location: "Lokasyon",
    productionLine: "Üretim Hattı",
    serialNo: "Seri No",
    brand: "Marka",
    model: "Model",
    purchaseDate: "Satın Alma Tarihi",
    warrantyEnd: "Garanti Bitiş",
    statusLabel: "Durum",
    authOperators: "Yetk. Operatörler",
    notes: "Notlar",
    lathe: "Torna",
    press_: "Pres",
    welding: "Kaynak",
    assembly: "Montaj",
    conveyor: "Konveyör",
    other: "Diğer",
    // Hata
    errNameIdRequired: "Makine adı ve ID zorunlu.",
    errFetch: "Makineler alınamadı",
    errGeneric: "Hata",
    // Detay sekmeleri
    tabOverview: "Canlı SCADA",
    tabOee: "OEE & Performans",
    tabFaults: "Arıza Geçmişi",
    tabMaintenance: "Bakım Takvimi",
    tabAlarms: "Alarm Geçmişi",
    tabParts: "Yedek Parçalar",
    tabStatusLog: "Durum Günlüğü",

    // Machines Localization Final
    tabMachineInfo: "Makine Bilgileri",
    noDataReceived: "Veri alınmadı",
    now: "Şimdi",
    secondsAgo: "sn önce",
    minutesAgo: "dk önce",
    hoursAgo: "sa önce",
    lastData: "SON VERİ",
    spindleSpeed: "SPINDLE DEVRİ",
    feedProgress: "İLERLEME",
    last60Measurements: "SON 60 ÖLÇÜM",
    waitingForLiveData: "CANLI VERİ BEKLENİYOR",
    productionUpper: "ÜRETİM",
    cycleUpper: "ÇEVRİM",
    scrapUpper: "FİRE",
    pcsUnit: "adet",
    machineUnreachable: "Makineye ulaşılamıyor",
    telemetryDisconnected: "Canlı telemetri kesildi. Son alınan veri:",
    telemetryNoNewData: "Makineden yeni telemetri alınamıyor.",
    activeFanucAlarm: "AKTİF FANUC ALARMI",
    connectionActiveNoAlarm: "Makine bağlantısı aktif — alarm bulunmuyor",
    activeWorkOrder: "Aktif İş Emri",
    product: "Ürün",
    operator: "Operatör",
    productionQuality: "Üretim & Kalite",
    produced: "Üretilen",
    reworkRequired: "Yeniden üretilmesi gereken:",
    noActiveWorkOrder: "Aktif iş emri bulunmuyor",
    workOrderDataHint: "Üretim ve kalite değerleri iş emri başlatıldığında burada gösterilecek.",
    cncProgram: "CNC Programı",
    programName: "Program Adı",
    tool: "Takım",
    lineBlock: "Satır / Blok",
    liveOee: "Canlı OEE",
    statusTimeline: "Durum Zaman Çizgisi",
    feedRate: "İlerleme (Feed)",
    program: "Program",
    partCount: "Parça Sayısı",
    alarm: "Alarm",
    none: "Yok",
    lastSeen: "Son Veri",
    connection: "Bağlantı",
    driver: "Driver",
    dataUnavailable: "Veri alınmadı",
    connectionLost: "Bağlantı Yok",
    waitingWorkOrder: "İş Emri Bekleniyor",
    machineAlarmReason: "Makine alarm verdi. Alarm kodu:",
    machineStoppedReason: "Makine durdu.",
    machineRunningReason: "Makine çalışmaya başladı.",
    // Metrik kartlar
    hours: "saat",
    avgMtbf: "Ort. Arızasız Çalışma",
    avgMttr: "Ort. Onarım Süresi",
    maintenanceCost: "Bakım Maliyeti",
    availability: "Kullanılabilirlik",
    performance: "Performans",
    quality: "Kalite",
    // Pasaport
    passport: "Makine Pasaportu",
    brandModel: "Marka / Model",
    location_: "Lokasyon",
    lastMaintenance: "Son Bakım",
    nextMaintenance: "Sonraki Bakım",
    all: "Tüm",
    // Anlık parametreler
    liveParams: "Anlık Parametreler",
    temperature: "Sıcaklık",
    vibration: "Titreşim",
    energy: "Enerji",
    rpm: "Devir (RPM)",
    cycleTime: "Çevrim Süresi",
    targetCycle: "Hedef Çevrim",
    riskScore: "Risk Skoru",
    opcua: "OPC-UA/MQTT",

    // Machine card final localization
    activeAlarmUpper: "AKTİF ALARM",
    noActiveAlarm: "Aktif alarm yok",
    alarmFallback: "Alarm",
    alarmSv0410: "X ekseni servo yükü yüksek",
    notConnected: "Bağlı değil",
    // OEE
    oee7days: "7 Günlük OEE Trendi",
    noOeeHistory: "OEE geçmişi bulunamadı",
    // Arıza
    noFaults: "Arıza kaydı bulunamadı",
    date: "Tarih",
    faultType: "Arıza Türü",
    description: "Açıklama",
    duration: "Süre",
    resolution: "Çözüm",
    min: "dk",
    // Bakım
    noMaintenance: "Bakım kaydı bulunamadı",
    // Alarmlar
    noAlarms: "Alarm kaydı bulunamadı",
    datetime: "Tarih/Saat",
    level: "Seviye",
    salesHierarchy: "Satış Hiyerarşisi",
    reportsTo: "Bağlı Olduğu Yönetici",
    activeUser: "Aktif kullanıcı",
    message: "Mesaj",
    warning: "UYARI",
    acknowledged: "Onaylandı",
    waiting: "Bekliyor",
    // Yedek Parça
    noPartsLinked: "Yedek parça bağlantısı tanımlanmamış",
    stockCode: "Stok Kodu",
    stock: "Stok",
    // Durum günlüğü
    noStatusLog: "Durum günlüğü bulunamadı",
    // Kart
    risk: "Risk",
    // İstatistikler
    total: "Toplam",
    running_: "Çalışıyor",
    faultMaintenance: "Bakım/Arıza",
    avgOee: "Ort. OEE",
    machine_: "Makine",
    // Live Machine Card RC2
    spindleCard: "Devir",
    feedCard: "Feed",
    cycleCard: "Çevrim",
    productionCard: "Üretim",
    targetCard: "Hedef",
    scrapCard: "Fire",
    temperatureCard: "Sıcaklık",
    liveDataUnavailable: "Canlı veri bağlantısı yok",
  },

  scrap: {
    title: "Hurda & Geri Dönüşüm",
    subtitle: "Üretim hurdası · Takım · Yağ/Sıvı · Otomatik KK entegrasyonu",
    loading: "Yükleniyor...",
    // Sekmeler
    tabRecords: "Hurdalar",
    tabTools: "Takım",
    tabFluids: "Yağ/Sıvı",
    tabDefinitions: "Tanımlar",
    tabAnalytics: "Analiz",
    // Butonlar
    addScrap: "Hurda Ekle",
    addTool: "Takım Ekle",
    addFluid: "Yağ/Sıvı Ekle",
    addDef: "Tanım Ekle",
    save: "Kaydet",
    update: "Güncelle",
    cancel: "İptal",
    saving: "Kaydediliyor...",
    // KPI
    kpiWeight: "Toplam Ağırlık (30g)",
    kpiValue: "Hurda Değeri",
    kpiRecovery: "Geri Kazanım",
    kpiPending: "Bekleyen Kayıt",
    kpiAuto: "otomatik",
    kpiToolFluid: "Takım + Yağ",
    // Form bölümleri
    secSource: "Kaynak Bilgisi",
    secMaterial: "Malzeme Cinsi",
    secQtyValue: "Miktar & Değer",
    secRecovery: "Geri Dönüşüm / İmha",
    // Form alanları
    editRecord: "Hurda Kaydını Düzenle",
    newRecord: "Yeni Hurda Kaydı",
    autoNote: "Otomatik oluşturuldu — kaynak bilgileri kilitli",
    autoLockNote: "Bu kayıt sistem tarafından otomatik oluşturuldu. Ürün kodu ve iş emri değiştirilemez, ancak geri dönüşüm bilgilerini güncelleyebilirsiniz.",
    formSubtitle: "Üretim hurdası / geri dönüşüm takibi",
    sourceType: "Kaynak Tipi",
    sourceManual: "Manuel Giriş",
    sourceWorkOrder: "İş Emri",
    sourceKkReject: "KK Red",
    sourceGeneral: "Genel / Karışık",
    productCode: "Ürün Kodu",
    productSearchPlaceholder: "FRN-001 veya ürün adı...",
    workOrderNo: "İş Emri No",
    materialType: "Malzeme Türü",
    scrapCategory: "Hurda Kategorisi",
    catQualityReject: "Kalite Red",
    catMachineFault: "Makine Arıza",
    catMaterialError: "Malzeme Hatası",
    catOperatorError: "Operatör Hatası",
    catMixed: "Karışık / Genel",
    catOther: "Diğer",
    date: "Tarih",
    weightKg: "Ağırlık (kg)",
    totalValue: "Toplam Değer",
    description_: "Açıklama",
    scrapReasonPlaceholder: "Hurda oluşma nedeni...",
    method: "Yöntem",
    company: "Firma",
    companyPlaceholder: "Hurdacı / firma",
    recoveryAmount: "Geri Kazanım (₺)",
    statusLabel: "Durum",
    notes: "Notlar",
    select: "Seçin",
    // Geri dönüşüm yöntemleri
    recHurdaciSat: "Hurdacıya Sat",
    recYenidenIsle: "Yeniden İşle",
    recGeriHammadde: "Geri Hammadde",
    recLisanliImha: "Lisanslı İmha",
    recBeklemede: "Beklemede",
    recImha: "İmha",
    // Durum
    statusBeklemede: "Beklemede",
    statusIsleniyor: "İşleniyor",
    statusTamamlandi: "Tamamlandı",
    statusToplandi: "Toplandı",
    statusSatildi: "Satıldı",
    // Takım tipleri
    toolElmasUc: "Elmas Uç",
    toolFreze: "Freze Bıçağı",
    toolMatkap: "Matkap Ucu",
    toolTaslamaTasi: "Taşlama Taşı",
    toolDiger: "Diğer",
    // Sıvı tipleri
    fluidHidrolik: "Hidrolik Yağ",
    fluidKesme: "Kesme Sıvısı",
    fluidSogutma: "Soğutma Suyu",
    fluidMotor: "Motor Yağı",
    fluidDiger: "Diğer",
    // Malzeme kategorileri
    catMetal: "Metal",
    catPlastik: "Plastik",
    catYag: "Yağ/Sıvı",
    catTakim: "Takım",
    // Takım formu
    toolFormTitle: "Takım Hurda Kaydı",
    toolName: "Takım Adı",
    toolType: "Takım Tipi",
    machine_: "Makine",
    quantity_: "Adet",
    unitPrice: "Birim Fiyat (₺)",
    total: "Toplam",
    pcs: "adet",
    // Sıvı formu
    fluidFormTitle: "Yağ / Sıvı Hurda Kaydı",
    fluidType: "Sıvı Tipi",
    volumeLt: "Hacim (lt)",
    containerCount: "Kap Adedi",
    containerType: "Kap Tipi",
    barrel: "Varil",
    canister: "Bidon",
    tank: "Tank",
    collectionCompany: "Toplama Firması",
    collectionDate: "Toplama Tarihi",
    salePrice: "Satış Fiyatı (₺)",
    // Tanım formu
    editDef: "Tanımı Düzenle",
    newDef: "Ürün Hurda Tanımı",
    defSubtitle: "KK otomasyonu için gerekli",
    defHint: "Örnek: FRN-001 üretirken başarılı her üründen 0.5 kg talaş, KK'dan geçmeyen her üründen 2.5 kg hurda çıkıyor.",
    scrapPerUnit: "Başarılı Ürün Başına (kg)",
    scrapPerUnitNote: "KK geçen her ürün için talaş",
    rejectWeight: "Red Ürün Ağırlığı (kg)",
    rejectWeightNote: "KK'dan geçmeyen her ürün",
    reject: "red",
    // Tablo
    scrapRecords: "Hurda Kayıtları",
    records_: "kayıt",
    product: "Ürün",
    material: "Malzeme",
    weight: "Ağırlık",
    value: "Değer (₺)",
    recovery: "Geri Dönüşüm",
    noRecords: "Hurda kaydı bulunamadı",
    addFirst: "İlk Kaydı Ekle",
    toolScrapTitle: "Takım Hurdaları (Elmas Uç, Freze vb.)",
    noTools: "Takım hurda kaydı bulunamadı",
    fluidScrapTitle: "Yağ & Sıvı Hurdaları",
    noFluids: "Yağ/sıvı hurda kaydı bulunamadı",
    defTitle: "Ürün Hurda Tanımları",
    defCount: "tanım",
    defInfo: "Ürün bazlı tanımlar sayesinde KK tamamlandığında sistem otomatik hurda kaydı oluşturur.",
    noDefs: "Henüz tanım yok.",
    // Filtre
    searchPlaceholder: "Ürün kodu, iş emri, malzeme...",
    allStatuses: "Tüm Durumlar",
    allMethods: "Tüm Yöntemler",
    // Analiz
    analyticsMaterialCat: "Malzeme Kategorisi",
    analyticsRecoveryMethod: "Geri Dönüşüm Yöntemi",
    analyticsDailyTrend: "Günlük Hurda Trendi (30 Gün)",
    analyticsTopProducts: "Ürün Bazlı Hurda (Top 10)",
    totalScrapValue: "Toplam Hurda Değeri",
    totalRecovery: "Toplam Geri Kazanım",
    netLoss: "Net Kayıp",
    noData: "Veri yok",
    noTrendData: "Trend verisi yok",
    // Hata / onay
    errProductCode: "Ürün kodu zorunlu",
    errWeight: "Ağırlık zorunlu",
    errSave: "Kaydedilemedi",
    errToolName: "Takım adı zorunlu",
    errVolume: "Hacim zorunlu",
    errMaterialType: "Malzeme türü zorunlu",
    confirmDelete: "Silinecek. Emin misiniz?",
    confirmDeleteDef: "Tanım silinecek. Emin misiniz?",
  
    catDiger: "Diğer",
    paginationScrapRecord: "hurda kaydı",
    paginationToolScrap: "takım hurdası",
    paginationFluidWaste: "sıvı atık",
    paginationScrapDefinition: "hurda tanımı",
},

  qualityPage: {
    title: "Kalite & Sevkiyat",
    subtitle: "Kalite kontrol · Ürün onayı · Müşteri sevkiyatı",
    refresh: "Yenile",
    loading: "Yükleniyor...",
    retry: "Tekrar Dene",
    cancel: "İptal Et",
    save: "Kaydet",
    saving: "Kaydediliyor...",
    goBack: "Vazgeç",
    yesCancelIt: "Evet, İptal Et",
    pcs: "adet",
    // Sekmeler
    tabQC: "Kalite Kontrol",
    tabShipment: "Sevkiyat",
    // Butonlar
    addQCRecord: "KK Kaydı",
    addShipment: "Sevkiyat",
    // KK Durum etiketleri
    qcPending: "Bekliyor",
    qcPassed: "Geçti",
    qcFailed: "Başarısız",
    qcPartial: "Kısmi Geçti",
    qcRework: "Yeniden İşle",
    qcScrap: "Hurda",
    // Sevkiyat durum etiketleri
    shipDraft: "Taslak",
    shipReady: "Hazır",
    shipPending: "Bekliyor",
    shipShipped: "Sevk Edildi",
    shipDelivered: "Teslim Edildi",
    shipCancelled: "İptal",
    // İstatistikler - KK
    totalQC: "Toplam KK",
    passed_: "Geçti",
    failed_: "Başarısız",
    avgPass: "Ort. Geçiş",
    // İstatistikler - Sevkiyat
    totalShip: "Toplam Sevkiyat",
    shipped_: "Sevk Edildi",
    pending_: "Bekleyen",
    // Filtre
    allStatuses: "Tüm Durumlar",
    searchQC: "Ürün, iş emri veya kontrol eden ara...",
    searchShip: "Müşteri, ürün veya sipariş ara...",
    noQCRecords: "Kalite kontrol kaydı yok.",
    noShipments: "Sevkiyat kaydı yok.",
    noMatch: "Eşleşen kayıt bulunamadı.",
    qcRecordCount: "kalite kaydı",
    shipRecordCount: "sevkiyat",
    // Tablo başlıkları
    customer_: "Müşteri",
    productName_: "Ürün",
    productCode: "Ürün Kodu",
    workOrder: "İş Emri",
    inspector: "Kontrol Eden",
    total_: "Toplam",
    checked_: "Kontrol",
    passPct: "Geçiş %",
    passRate: "Geçiş Oranı",
    statusLabel: "Durum",
    totalOrder: "Sipariş Miktarı",
    shippedQty: "Sevk Miktarı",
    orderNo: "Sipariş No",
    shipDate: "Sevk Tarihi",
    shipProgress: "Sevkiyat İlerlemesi",
    order_: "Sipariş",
    remaining_: "Kalan",
    product_: "Ürün",
    woShort: "İE",
    // QC detay modal
    inspectionDetails: "Kontrol Detayları",
    productName: "Ürün Adı",
    lotNo: "Lot No",
    notes_: "Notlar",
    inspDate: "Kontrol Tarihi",
    thisQcTotal: "Bu KK Toplam",
    thisQcPassed: "Bu KK Geçen",
    thisQcFailed: "Bu KK Başarısız",
    thisQcPct: "Bu KK Geçiş %",
    qcCancelConfirm: "Bu KK kaydını iptal etmek istediğinizden emin misiniz?",
    qcCancelledMsg: "KK kaydı iptal edildi.",
    // Sevkiyat detay modal
    shipment: "Sevkiyat",
    totalQty: "Toplam Miktar",
    shippedOf: "Sevk Edilen",
    remainingToShip: "Kalan Sevk Edilecek",
    readyToShip: "sevke hazır",
    doShipment: "Sevkiyat Yap",
    shipNow: "Sevk Et",
    invoiceRequired: "Fatura kesilmeden sevkiyat yapılamaz. Önce bu siparişe fatura işaretleyin.",
    invoiceRequiredShip: "Fatura kesilmeden sevkiyat yapılamaz. Önce satış siparişinden fatura işaretleyin.",
    invoiceRequiredCard: "Fatura kesilmedi — sevkiyat yapılamaz",
    shipQtyLabel: "Sevk edilecek miktar (max: {n} adet)",
    allShipped: "Tüm ürünler sevk edildi.",
    shipCancelConfirm: "Sevkiyatı iptal etmek istediğinizden emin misiniz?",
    willBeReturned: "stoka geri eklenecek.",
    cancelReasonPlaceholder: "İptal sebebi...",
    shipCancelledMsg: "Sevkiyat iptal edildi.",
    shipCancelledStock: "İptal edildi. {n} adet stoka eklendi.",
    customerCancel: "Müşteri iptali — depoya alındı",
    notInvoiced: "Fatura kesilmedi",
    // QC form
    newQCRecord: "Kalite Kontrol Kaydı",
    workOrderSelect: "İş Emri",
    onlyInProduction: "Sadece üretimdeki iş emirleri",
    selectWO: "İş Emri Seçin",
    noWOInProduction: "Üretimde olan iş emri yok.",
    orderQty: "Sipariş Miktarı",
    prevPassed: "Daha Önce Geçti",
    remainingQC: "Kalan KK",
    woPassRate: "İş Emri Genel Geçiş Oranı",
    wo100Pct: "Bu iş emri %100 kalite kontrolünden geçti.",
    checkedQty: "Kontrol Edilen Miktar",
    failQty: "Başarısız Miktar",
    passQtyAuto: "Geçen Miktar (Otomatik)",
    inspType: "Kontrol Türü",
    inspFinal: "Final Kontrol",
    inspInProcess: "Proses İçi",
    inspIncoming: "Giriş Kontrolü",
    inspOutgoing: "Çıkış Kontrolü",
    max: "Maks",
    date_: "Tarih",
    // Sevkiyat form
    editShipment: "Sevkiyat Düzenle",
    selectPendingShipment: "Bekleyen Sevkiyat Seç",
    selectShipment: "Sevkiyat Seçin",
    noPendingShipments: "Bekleyen sevkiyat yok.",
    noCustomer: "Müşteri Yok",
    shippable: "Sevk Edilebilir",
    thisShipQty: "Bu Sevkiyat Miktarı",
    unit_: "Birim",
    carrier: "Taşıyıcı",
    partialShipNote: "Kısmi Sevkiyat: {qty} / {max} {unit}. Kalan: {remaining} {unit} bekleyecek.",
    allPendingWillShip: "Tüm bekleyen miktar sevk edilecek.",
    errSelectShipment: "Sevkiyat seçiniz.",
    errMaxShip: "Maksimum sevk edilebilir",
    // Hatalar
    errFetchQC: "Kalite verileri alınamadı",
    errSelectWO: "İş emri seçiniz.",
    errQtyZero: "Kontrol edilen miktar 0'dan büyük olmalı.",
    errQtyExceeds: "Geçen + başarısız miktar, toplam miktardan fazla olamaz.",
    err100Pct: "Bu iş emri %100 kalite kontrolünden geçti.",
    errRemainingQty: "Kalan kontrol miktarı",
    errShipQtyZero: "Sevk miktarı 0'dan büyük olmalı.",
    errShipMaxPrefix: "En fazla",
    errShipUpdate: "Sevkiyat güncellenemedi.",
    errSave: "Hata",
    cancelFailed: "İptal başarısız.",
    connectionError: "Bağlantı hatası.",

    // RC1.1A — workflow / assembly / defective component labels
    finalQcPassedLabel: "✅ Final KK Geçti",
    inProcessQcPassedLabel: "✅ İç Proses KK Geçti",

    woStatusCompleted: "✅ Tamamlandı",
    woStatusPlanned: "📋 Planlandı",
    woStatusInProgress: "🔄 Üretimde",
    woStatusAssemblyWaiting: "⏳ Montaj Bekliyor",
    woStatusQcWaiting: "🧪 İç Proses KK Bekliyor",
    woStatusFinalQcWaiting: "🧪 Final KK Bekliyor",
    woStatusWaiting: "📋 Bekliyor",

    assemblyInProgress: "🔧 Montajda",
    assemblyPending: "⏳ Montaj Bekliyor",
    assemblyCompleted: "✅ Montaj Tamamlandı",

    defectiveComponents: "🔴 Hatalı Bileşenler",
    dispositionRemanufacture: "🔄 Yeniden Üret",
    dispositionStock: "📦 Stoktan Karşıla",
    dispositionPurchase: "🛒 Satın Al",
    dispositionScrap: "🗑️ Hurda",
    dispositionUseAsIs: "✅ Olduğu Gibi Kullan",

    // RC1.1C — semantic final
    component: "Bileşen",
    stock: "Stok",
    pieceCount: "Adet",
    defectType: "Hata Tipi",
    decision: "Karar",

    defectDimensional: "Boyut",
    defectVisual: "Görsel",
    defectFunctional: "Fonksiyon",
    defectMaterial: "Malzeme",
    defectOther: "Diğer",

    totalOrderLabel: "Toplam Sipariş",
    passedQtyLabel: "Geçen",

    errFullShipmentBeforeDelivered: "Teslim edildi yapmadan önce tam sevkiyat yapılmalı.",
  },

  qualityCost: {
    title: "Kalite Maliyet Raporu",
    subtitle: "Cost of Quality · NCR Maliyetleri · Tekrar Eden Problemler · ISO 9001",
    loading: "Yükleniyor...",
    // Ay isimleri
    jan: "Oca", feb: "Şub", mar: "Mar", apr: "Nis",
    may: "May", jun: "Haz", jul: "Tem", aug: "Ağu",
    sep: "Eyl", oct: "Eki", nov: "Kas", dec: "Ara",
    // Hata kategorileri
    catDimensional:   "Boyutsal",
    catVisual:        "Görsel",
    catFunctional:    "Fonksiyonel",
    catMaterial:      "Malzeme",
    catProcess:       "Proses",
    catDocumentation: "Dokümantasyon",
    catOther:         "Diğer",
    // KPI kartları
    kpiTotalCost:      "Toplam Kalite Maliyeti",
    kpiInternalError:  "İç Hata Maliyeti",
    kpiInternalSub:    "İşçilik + Makine",
    kpiExternalError:  "Dış Hata Maliyeti",
    kpiExternalSub:    "Nakliye + Ceza",
    kpiScrapLoss:      "Hurda Net Kaybı",
    kpiCustomerReturn: "Müşteri İadesi",
    records:           "kayıt",
    thisMonth:         "Bu ay",
    // Sekmeler
    tabSummary:    "Özet",
    tabRecurring:  "Tekrarlayan",
    tabKaizen:     "Kaizen Önerileri",
    tabTrend:      "Trend",
    // Özet sekmesi
    costBreakdown:  "Maliyet Dağılımı",
    internalError:  "İç Hata (İşçilik, Makine)",
    rework:         "Yeniden İşleme",
    externalError:  "Dış Hata (Nakliye, Ceza)",
    otherImpact:    "Diğer Kalite Etkisi",
    scrapNetLoss:   "Hurda Net Kaybı",
    total:          "TOPLAM",
    errorCategory:  "Hata Kategorisi",
    ncrCount:       "NCR Sayısı",
    costTl:         "Maliyet (₺)",
    noNcrThisMonth: "Bu ay NCR yok",
    criticalNcr:    "Kritik NCR",
    scrapWeight:    "Hurda Ağırlığı",
    recovery:       "Geri Kazanım",
    // Tekrarlayan
    noRecurring:    "Bu ay tekrarlayan problem yok! Harika.",
    recurringTitle: "Tekrarlayan Problemler — Acil Kaizen Gerektirir!",
    product:        "ürün",
    productCode:    "Ürün Kodu",
    totalCost:      "Toplam Maliyet",
    severities:     "Şiddetler",
    riskLevel:      "Risk Seviyesi",
    riskCritical:   "KRİTİK",
    riskHigh:       "YÜKSEK",
    riskMedium:     "ORTA",
    times:          "kez",
    // Kaizen
    kaizenInfo:       "Son 90 günde 2+ NCR alan ürünler için otomatik Kaizen önerisi oluşturuldu. Bu problemler tekrar etmeden önce kök neden analizi yapılmalı.",
    noKaizen:         "Son 90 günde tekrarlayan problem yok.",
    urgencyVeryUrgent:"Çok Acil",
    urgencyUrgent:    "Acil",
    urgencySuggested: "Önerilen",
    last90Days:       "Son 90 günde",
    recorded:         "kaydı",
    totalCost_:       "Toplam maliyet",
    kaizenAction:     "Önerilen Aksiyon: Kök neden analizi yapın → CAPA oluşturun → Proses kontrol planını güncelleyin",
    // Trend
    trend12months:    "12 Aylık Kalite Maliyet Trendi",
    trendQualityCost: "Kalite Maliyeti",
    trendNcrCount:    "NCR Sayısı",
    trendReturns:     "Müşteri İadesi",
    noTrendData:      "Trend verisi yok",
    monthlyDetail:    "Aylık Detay",
    month_:           "Ay",
    customerReturn:   "Müşteri İadesi",
    qualityCost_:     "Kalite Maliyeti",
    statusLabel:      "Durum",
    statusCritical:   "Kritik",
    statusHigh:       "Yüksek",
    statusNormal:     "Normal",
    noData:           "Veri yok",
  },

  stockPage: {
    title: "Stok & Tedarikçi",

    // RC1.1B — Assembly Material Requests
    assemblyRequestsTitle: "🔧 Montaj İçin Malzeme Talepleri",
    assemblyRequest: "Talep",
    assemblyWorkOrder: "İş Emri",
    assemblyMaterial: "Malzeme",
    assemblyQuantity: "Miktar",
    assemblyRequestedBy: "Talep Eden",
    assemblyStock: "Stok",
    assemblyStatus: "Durum",
    assemblyAction: "İşlem",
    assemblyInStock: "🟢 Depoda Var",
    assemblyOutOfStock: "🔴 Depoda Yok",
    assemblyDefaultReason: "Montaj malzeme talebi",

    assemblyApproveNote: "Montaj talebi teslim edildi",
    assemblyDeliveredSuccess: "Malzeme teslim edildi ✅",
    assemblyRejectReasonPrompt: "Red sebebi:",
    assemblyRejectedSuccess: "Talep reddedildi",

    assemblyStatusWaiting: "⏳ Bekliyor",
    assemblyStatusDelivered: "✅ Teslim Edildi",
    assemblyStatusRejected: "❌ Reddedildi",

    assemblyNoPending: "Bekleyen montaj talebi yok",
    assemblyNoPendingHint: "Montaj ekranından “Talep Et” yapılınca burada görünür",

    approveAssemblyRequest: "Onayla",
    rejectAssemblyRequest: "Reddet",

    subtitle: "Malzeme yönetimi · Hareketler · Tedarikçi performansı",
    refresh: "Yenile",
    loading: "Yükleniyor...",
    retry: "Tekrar Dene",
    cancel: "İptal",
    save: "Kaydet",
    saving: "Kaydediliyor...",
    update: "Güncelle",
    add: "Ekle",
    edit: "Düzenle",
    detail: "Detay",
    actions: "İşlem",
    // Sekmeler
    tabRaw:       "Hammadde & Malzeme",
    tabFinished:  "Bitmiş Ürün Stoku",
    tabSemi:      "Yarı Mamül Stoku",
    tabSuppliers: "Tedarikçiler",
    tabRequests:  "Sarf Talepleri",
    // Butonlar
    addMaterial:  "Malzeme Ekle",
    addProduct:   "Ürün Ekle",
    addSemi:      "Yarı Mamül Ekle",
    addSupplier:  "Tedarikçi Ekle",
    newMaterial:  "Yeni Malzeme",
    newSupplier:  "Yeni Tedarikçi",
    // Durum
    statusEmpty:   "Tükendi",
    statusLow:     "Kritik",
    statusWarning: "Az",
    statusOk:      "Yeterli",
    statusLabel:   "Durum",
    allStatuses:   "Tüm Durumlar",
    allCategories: "Tüm Kategoriler",
    // Hareket tipleri
    movReceipt:  "Mal Girişi",
    movIssue:    "Mal Çıkışı",
    movTransfer: "Transfer",
    movAdjust:   "Sayım Düzeltme",
    // Malzeme bilgileri
    materialName:  "Malzeme Adı",
    stockCode:     "Stok Kodu",
    category:      "Kategori",
    currentStock:  "Mevcut Stok",
    minStock:      "Min. Stok",
    maxStock:      "Maks. Stok",
    unit_:         "Birim",
    unitPrice:     "Birim Fiyat",
    totalValue_:   "Toplam Değer",
    supplier_:     "Tedarikçi",
    lastReceipt:   "Son Giriş",
    lastIssue:     "Son Çıkış",
    location:      "Depo / Konum",
    // Planlama parametreleri
    planningParams: "Planlama Parametreleri",
    reorderPoint:   "Yeniden Sipariş Noktası",
    eoq:            "EOQ (Ekonomik Sipariş)",
    safetyStock:    "Güvenlik Stoğu",
    leadTime:       "Temin Süresi",
    days:           "gün",
    dayShort:       "g",
    batchTracking:  "Lot Takibi",
    serialTracking: "Seri No Takibi",
    qualityCheck:   "Kalite Kontrolü",
    fifoLifo:       "FIFO / LIFO",
    abcClass:       "ABC Sınıfı",
    abcCritical:    "Kritik",
    abcImportant:   "Önemli",
    abcLow:         "Düşük",
    active:         "Aktif",
    passive:        "Pasif",
    required:       "Gerekli",
    notRequired:    "Gerekmiyor",
    // Sekme başlıkları
    materialInfo:   "Malzeme Bilgileri",
    stockLevel:     "Stok Seviyesi",
    tabOverview:    "Genel Bakış",
    tabMovements:   "Hareketler",
    tabReorder:     "Yeniden Sipariş",
    // Hareketler tablosu
    date_:          "Tarih",
    type_:          "Tür",
    qty:            "Miktar",
    afterStock:     "Sonraki Stok",
    notes:          "Notlar",
    user:           "Kullanıcı",
    noMovements:    "Hareket kaydı bulunamadı",
    // Yeniden sipariş
    autoPurchaseSuggestion: "Otomatik Satın Alma Önerisi",
    suggestedOrder: "Önerilen Sipariş",
    reorderAlert:   "Stok yeniden sipariş noktasına ulaştı! Tedarikçiye otomatik sipariş talebi gönderilebilir.",
    lastPrice:      "Son fiyat",
    // Form alanları
    unitPriceTl:    "Birim Fiyat (₺)",
    package:        "Paket",
    pcs:            "adet",
    inUnit:         "cinsinden",
    quantity:       "Miktar",
    reserved:       "Rezerve",
    openWO:         "Açık İş Emirleri",
    available:      "Kullanılabilir",
    // Tedarikçi kartı
    generalSupplier: "Genel Tedarikçi",
    productCount:   "Ürün Sayısı",
    activeOrders:   "Aktif Sipariş",
    leadTimeDays:   "Temin Süresi",
    paymentDays:    "Ödeme Vadesi",
    // Tedarikçi detay
    contact:        "İletişim",
    contactPerson:  "Yetkili",
    phone_:         "Telefon",
    email_:         "E-posta",
    address_:       "Adres",
    city_:          "Şehir",
    taxNo:          "Vergi No",
    performance:    "Performans",
    rating_:        "Puan",
    deliverySuccess:"Teslimat Başarısı",
    qualityScore:   "Kalite Puanı",
    leadTimeDaysLabel: "Temin Süresi (gün)",
    paymentDaysLabel:  "Ödeme Vadesi (gün)",
    rating1to5:     "Puan (1-5)",
    contractEnd:    "Sözleşme Bitiş",
    totalPurchase:  "Toplam Alım",
    lastOrder:      "Son Alım",
    recentOrders:   "Son Siparişler",
    noOrders:       "Sipariş kaydı yok",
    material:       "Malzeme",
    amount:         "Tutar",
    delivered:      "Teslim Edildi",
    waiting:        "Bekliyor",
    // Bitmiş ürün
    totalProducts:  "Toplam Ürün",
    totalSemi:      "Toplam Yarı Mamül",
    readyToShip_:   "Sevkiyata Hazır",
    finishedStockInfo: "Bitmiş ürün stoku, tamamlanan iş emirlerinden otomatik olarak güncellenir. Sevkiyat modülünden çıkış yapılır.",
    searchProduct:  "Ürün adı veya kodu ara...",
    noFinishedGoods:"Henüz bitmiş ürün stoku yok.",
    noProductFound: "Ürün bulunamadı",
    productName:    "Ürün",
    productNameHeader: "Ürün Adı",
    noProductMatch: "Eşleşen ürün bulunamadı.",
    productCode:    "Ürün Kodu",
    total_:         "Toplam",
    workOrder:      "İş Emri",
    customer:       "Müşteri",
    productionDate: "Üretim Tarihi",
    source:         "Kaynak",
    pendingWarehouse:"Depo Bekliyor",
    shipped:        "Sevk Edildi",
    ready:          "Hazır",
    customerCancel: "Müşteri İptali",
    customerCancelNote: "Bu ürün müşteri iptali sonucu depoya alındı",
    warehouseAcceptNote: "Depo kabul notu (opsiyonel):",
    warehouseAccepted:   "Ürün depoya alındı!",
    acceptToWarehouse:   "Depoya Al",
    normalProduction:    "Normal Üretim",

    // Yarı mamül
    semiStockInfo: "Yarı mamül stoku, alt iş emirleri tamamlandığında veya manuel girişle güncellenir. İş emri başlatılınca otomatik kullanılır.",
    searchSemi:    "Yarı mamül adı veya kodu ara...",
    noSemiGoods:   "Yarı mamül stoku yok.",
    semiCount:     "yarı mamül",
    manualSource:  "✋ Manuel",
    productionSource: "🏭 Üretim",
    inStock:        "Depoda",
    inStockSemi:     "Depoda",
    reservedSemi:    "Rezerve",
    mainWarehouse:  "Ana Depo",
    // Hammadde stats
    totalItems:     "Toplam Kalem",
    criticalStock:  "Kritik Stok",
    supplierCount:  "Tedarikçi",
    criticalStockAlert: "kalem kritik stok seviyesinde! Satın alma talebi oluşturmanız önerilir.",
    searchMaterial: "Malzeme adı veya stok kodu...",
    noMaterials:    "Henüz malzeme kaydı yok.",
    noMaterialFound:"Malzeme bulunamadı",
    noMatch:        "Filtrelerle eşleşen malzeme bulunamadı.",
    loadingStock:   "Stok yükleniyor...",
    // Tedarikçi stats
    noSuppliers:    "Tedarikçi kaydı yok.",
    noSupplierMatch: "Eşleşen tedarikçi bulunamadı.",
    searchSupplier: "Tedarikçi ara...",
    supplierName:   "Tedarikçi Adı",
    code:           "Kod",
    // Sayım
    materialCount:  "malzeme",
    finishedCount:  "bitmiş ürün",
    supplierCount_: "tedarikçi",
    requestCount:   "talep",
    // Talep
    reqTotal:       "Toplam",
    reqPending:     "Bekleyen",
    reqApproved:    "Onaylanan",
    reqRejected:    "Reddedilen",
    reqAll:         "Tümü",
    requestConsumable: "Sarf Talep Et",
    newRequest:     "Yeni Sarf Talebi",
    reqMaterialPlaceholder: "Kesici takım, yağ, eldiven...",
    current:        "Mevcut",
    department:     "Departman",
    deptPlaceholder:"Üretim, Bakım...",
    machine_:       "Makine",
    reqReason:      "Talep Sebebi",
    reqReasonPlaceholder: "Tüketildi, Bozuldu, Stok azaldı...",
    sendRequest:    "Talep Gönder",
    requestedBy:    "Talep Eden",
    noRequests:     "Talep bulunamadı",
    approve:        "Onayla",
    reject:         "Reddet",
    rejectReasonPrompt: "Red sebebi:",

    // RC1.1C.4 — final status/action labels
    requestDelivered: "Teslim Edildi",
    requestDeliveredCount: "Teslim Edilen",
    stockUnavailable: "Stok Yok",
    deliverAction: "Teslim Et",
    semiStatusInStock: "✅ Depoda",
    semiStatusWaiting: "⏳ Bekliyor",
    // Hata
    errValidQty:    "Geçerli miktar girin.",
    errGeneric:     "Hata",
    errNameRequired:"Ad zorunlu.",
    errFetchStock:  "Stok alınamadı",
    connectionError:"Bağlantı hatası",
    error_:         "Hata",

    // Kategori etiketleri
    catRawMaterial:  "Hammadde",
    catConsumable:   "Sarf",
    catSemiFinished: "Yarı Mamül",
    catSparePart:    "Yedek Parça",
    catElectronic:   "Elektronik",
    catChemical:     "Kimyasal",
    catPackaging:    "Ambalaj",
  },

  maintenance_: {
    title: "Bakım & Servis",
    subtitle: "Önleyici bakım · Arıza müdahale · Servis onay akışı",
    refresh: "Yenile",
    loading: "Yükleniyor...",
    retry: "Tekrar Dene",
    cancel: "İptal",
    saving: "Kaydediliyor...",
    update: "Güncelle",
    plan: "Planla",
    detail: "Detay",
    actions: "İşlem",
    approve: "Onayla",
    reject: "Reddet",
    // Durum etiketleri
    statusPending:    "Bekliyor",
    statusInProgress: "Devam Ediyor",
    statusCompleted:  "Tamamlandı",
    statusCancelled:  "İptal",
    statusOverdue:    "Gecikmiş",
    statusLabel:      "Durum",
    allStatuses:      "Tüm Durumlar",
    // Bakım türleri
    typePreventive:  "Önleyici",
    typeCorrective:  "Düzeltici",
    typePredictive:  "Tahmine Dayalı",
    typeInspection:  "Muayene",
    typeCalibration: "Kalibrasyon",
    allTypes:        "Tüm Türler",
    // Öncelik
    priorityLow:      "Düşük",
    priorityNormal:   "Normal",
    priorityHigh:     "Yüksek",
    priorityCritical: "Kritik",
    // Arıza türleri
    faultMechanical:  "Mekanik Arıza",
    faultElectrical:  "Elektrik Arızası",
    faultSoftware:    "Yazılım Hatası",
    faultVibration:   "Titreşim / Gürültü",
    faultOverheat:    "Aşırı Isınma",
    faultLeak:        "Sızdırma / Kaçak",
    faultCalibration: "Kalibrasyon Bozukluğu",
    faultSparePart:   "Yedek Parça Değişimi",
    faultOther:       "Diğer",
    // Takvim
    calendar:          "Bakım Takvimi",
    maintenanceShort:  "Bakım",
    // Detay modal sekmeleri
    tabOverview: "Genel Bakış",
    tabParts:    "Kullanılan Parçalar",
    tabCost:     "Maliyet",
    // Detay bilgileri
    maintenanceInfo: "Bakım Bilgileri",
    title_:          "Başlık",
    machine_:        "Makine",
    type_:           "Bakım Türü",
    priority_:       "Öncelik",
    technician:      "Atanan Teknisyen",
    technicianShort: "Teknisyen",
    scheduledDate:   "Planlanan Tarih",
    startedAt:       "Başlangıç",
    completedAt:     "Bitiş",
    estimatedHrs:    "Tahmini Süre",
    actualHrs:       "Gerçek Süre",
    hours:           "saat",
    description_:    "Açıklama",
    noDescription:   "Açıklama girilmemiş.",
    workDone:        "Yapılan İşlem",
    notCompleted:    "Henüz tamamlanmadı.",
    nextMaintenance: "Sonraki Bakım",
    planned:         "Planlanan",
    // Parçalar
    partName:  "Parça Adı",
    stockCode: "Stok Kodu",
    qty:       "Miktar",
    unitPrice: "Birim Fiyat",
    total_:    "Toplam",
    noParts:   "Parça kaydı yok",
    // Maliyet
    laborCost:     "İşçilik Maliyeti",
    partsCost:     "Parça Maliyeti",
    totalCost_:    "Toplam Maliyet",
    estimatedCost: "Planlanan Maliyet",
    actualCost:    "Gerçek Maliyet",
    variance_:     "Fark",
    // Servis talebi detay
    serviceRequest:  "Servis Talebi",
    requester:       "Talep Eden",
    faultType_:      "Arıza Türü",
    approvedBy:      "Onaylayan",
    approvedAt:      "Onay Tarihi",
    estimatedCostTl: "Tahmini Maliyet",
    // Servis formu
    createServiceRequest: "Servis Talebi Oluştur",
    serviceRequestNote:   "Talep yöneticiye iletilecek ve onaylanacak",
    requestSent:          "Servis Talebi Gönderildi!",
    requestSentNote:      "Talebiniz yöneticiye iletildi. Onay durumunu Servis Talepleri sekmesinden takip edebilirsiniz.",
    machineId_:           "Makine ID",
    selectFaultType:      "Seçiniz...",
    faultDescription:     "Arıza Açıklaması",
    faultDescPlaceholder: "Arızayı detaylı açıklayın. Ne zaman başladı? Nasıl bir belirti var?",
    optional:             "İsteğe bağlı",
    contactInternal:      "İletişim (Dahili)",
    internalNo:           "Dahili no",
    approvalFlow:         "Talep gönderildikten sonra yönetici onaylar → Teknisyen atanır → Bakım planına dönüştürülür",
    sending:              "Gönderiliyor...",
    sendRequest:          "Talebi Gönder",
    // Form
    editMaintenance: "Bakım Düzenle",
    newMaintenance:  "Yeni Bakım Planla",
    estimatedHrsTl:  "Tahmini Süre (saat)",
    nextMaintDate:   "Sonraki Bakım Tarihi",
    planMaintenance: "Bakım Planla",
    // İstatistikler
    statTotal:   "Toplam Bakım",
    statPending: "Bekleyen",
    statOverdue: "Gecikmiş",
    statCost:    "Toplam Maliyet",
    overdueAlert: "bakım planlanmış tarihini geçti! Acil aksiyon gerekiyor.",
    // Sekmeler
    tabMaintenance: "Bakım Planları",
    tabService:     "Servis Talepleri",
    // Filtre/Arama
    searchPlaceholder:        "Başlık veya makine ara...",
    searchServicePlaceholder: "Makine veya açıklama ara...",
    // Sayım
    recordCount:      "bakım kaydı",
    serviceCount:     "servis talebi",
    noRecords:        "Henüz bakım kaydı yok.",
    noServiceRecords: "Servis talebi bulunamadı.",
    noMatch:          "Filtrelerle eşleşen kayıt bulunamadı.",
    // Tarih
    date_: "Tarih",
    // Hata
    errFetch:        "Bakım verileri alınamadı",
    errGeneric:      "Hata",
    errMachineDesc:  "Makine ID ve açıklama zorunlu.",
    errTitleMachine: "Başlık ve makine ID zorunlu.",
      machineIdPlaceholder: 'Örn: CNC-001',
},

  energyPage: {
    title: "Enerji Takibi",
    subtitle: "Gerçek zamanlı tüketim · Maliyet analizi · CO₂ takibi · Eşik ayarları",
    refresh: "Yenile",
    settings: "Ayarlar",
    loading: "Yükleniyor...",
    cancel: "İptal",
    save: "Kaydet",
    saving: "Kaydediliyor...",
    detail: "Detay",
    // Sekmeler
    tabOverview: "Genel Bakış",
    tabMachines: "Makine Bazlı",
    tabAnalysis: "Analiz",
    // Periyot
    show: "Göster",
    periodHourly:  "Saatlik",
    periodDaily:   "Günlük",
    periodMonthly: "Aylık",
    // Metrik kartlar
    currentPower_:  "Anlık Güç",
    todayConsump_:  "Bugün Tüketim",
    todayCost_:     "Bugün Maliyet",
    co2Emission:    "CO₂ Emisyonu",
    threshold:      "Eşik",
    day:            "gün",
    yesterday:      "Dün",
    monthlyEst:     "Aylık tahmini",
    monthly_:       "Aylık",
    // Eşik göstergeleri
    dailyConsumption: "Günlük Tüketim",
    dailyCost:        "Günlük Maliyet",
    // Uyarı
    kwhThresholdAlert:  "Günlük tüketim eşiği aşıldı",
    costThresholdAlert: "Günlük maliyet eşiği aşıldı",
    // Grafik
    energyConsumption: "Enerji Tüketimi",
    cost_:             "Maliyet",
    noEnergyData:      "Enerji verisi bulunamadı",
    // Tarife
    tariffDay:   "Gündüz Tarifesi",
    tariffNight: "Gece Tarifesi",
    tariffPeak:  "Puant Tarifesi",
    // Makine tablosu
    machine_:           "Makine",
    currentPower:       "Anlık Güç",
    todayKwh:           "Bugün (kWh)",
    todayCostTl:        "Bugün (₺)",
    monthKwh:           "Bu Ay (kWh)",
    monthCostTl:        "Bu Ay (₺)",
    efficiency:         "Verimlilik",
    noMachineData:      "Makine enerji verisi bulunamadı",
    machineConsumptionToday: "Makine Bazlı Bugünkü Tüketim",
    // Makine detay modal
    sevenDayHistory:     "7 günlük enerji geçmişi",
    sevenDayConsumption: "7 Günlük Tüketim",
    todayConsump:        "Bugünkü Tüketim",
    todayCost:           "Bugünkü Maliyet",
    noHistoryData:       "Geçmiş veri bulunamadı",
    // Analiz
    weeklyComparison:  "Haftalık Karşılaştırma",
    monthlyComparison: "Aylık Karşılaştırma",
    thisWeek:          "Bu Hafta",
    lastWeek:          "Geçen Hafta",
    thisMonth:         "Bu Ay",
    lastMonth:         "Geçen Ay",
    thisMonthTotal:    "Bu Ay Toplam",
    thisMonthCost:     "Bu Ay Maliyet",
    thisMonthCo2:      "Bu Ay CO₂",
    lastMonthCost:     "Geçen Ay Maliyet",
    yearlyEstimate:    "Yıllık Tahmini",
    // Ayarlar modal
    settingsTitle:        "Enerji Ayarları",
    sectionKwh:           "Tüketim Eşikleri (kWh/gün)",
    sectionCost:          "Maliyet Eşikleri (₺/gün)",
    sectionCo2:           "CO₂ Eşikleri (kg/gün)",
    sectionPeak:          "Güç Eşikleri (kW)",
    sectionTariff:        "Elektrik Tarifeleri (₺/kWh)",
    sectionNotification:  "Bildirim Ayarları",
    warningThreshold:     "Uyarı Eşiği",
    criticalThreshold:    "Kritik Eşik",
    email_:               "E-posta",
    smsTelegram:          "SMS / Telegram",
    errGeneric:           "Hata",
  },

  kaizenPage: {
    cancel:"İptal",
    title: "Kaizen & Lean & 5S",
    subtitle: "Sürekli iyileştirme · 5S denetim · Tasarruf takibi",
    refresh: "Yenile", loading: "Yükleniyor...",
    saving: "Kaydediliyor...", update: "Güncelle", submit: "Gönder",
    actions: "İşlem", reject: "Reddet",
    statusIdea:"Fikir", statusReviewing:"İnceleniyor", statusApproved:"Onaylandı",
    statusImplementing:"Uygulanıyor", statusCompleted:"Tamamlandı", statusRejected:"Reddedildi",
    allStatuses:"Tüm Durumlar",
    catSafety:"İş Güvenliği", catQuality:"Kalite", catEfficiency:"Verimlilik",
    catCost:"Maliyet", catEnvironment:"Çevre", catErgonomics:"Ergonomi",
    catMaintenance:"Bakım", catOther:"Diğer", allCategories:"Tüm Kategoriler",
    seiriLabel:"Seiri (Ayıklama)", seiriDesc:"Gereksiz malzemeleri kaldır",
    seitonLabel:"Seiton (Düzenleme)", seitonDesc:"Her şeyin bir yeri olsun",
    seisoLabel:"Seiso (Temizlik)", seisoDesc:"Temiz ve düzenli çalışma alanı",
    seiketsuLabel:"Seiketsu (Standart)", seiketsuDesc:"Standartları belirle ve uygula",
    shitsukeLabel:"Shitsuke (Disiplin)", shitsukeDesc:"Alışkanlıkları sürdür",
    tabKaizen:"Kaizen Önerileri", tabFives:"5S Denetimler", tabLean:"Lean Analiz",
    tabPdca:"PDCA Döngüsü", tabSavings:"Maliyet-Fayda", tabSuggestions:"Sistem Önerileri",
    addSuggestion:"Öneri Ekle", doAudit:"Denetim Yap",
    createWorkOrder:"İş Emri Oluştur", createKaizen:"Kaizen Oluştur",
    statTotal:"Toplam Öneri", statCompleted:"Tamamlanan", statOngoing:"Devam Eden",
    statSaving:"Tahmini Tasarruf", statFivesScore:"5S Ort. Puan",
    kaizenInfo:"Kaizen Bilgileri", category_:"Kategori", priority_:"Öncelik",
    submitter:"Gönderen", department_:"Departman", machineArea:"Makine/Alan",
    submitDate:"Gönderim Tarihi", targetDate_:"Hedef Tamamlanma", estimatedSaving_:"Tahmini Tasarruf",
    problem_:"Problem", suggestion_:"Öneri", result_:"Sonuç",
    editKaizen:"Kaizen Düzenle", newKaizen:"Yeni Kaizen Önerisi",
    title_:"Başlık", estimatedSavingTl:"Tahmini Tasarruf (₺)",
    prioLow:"Düşük", prioNormal:"Normal", prioHigh:"Yüksek", prioCritical:"Kritik",
    problemDef:"Problem Tanımı", problemPh:"Mevcut durumu ve sorunu açıklayın...",
    improvementSuggestion:"İyileştirme Önerisi", suggestionPh:"Çözüm önerinizi detaylı açıklayın...",
    resultNote:"Sonuç / Uygulama Notu", resultPh:"Uygulama sonrası doldurun...",
    editFivesAudit:"5S Denetimi Düzenle", newFivesAudit:"Yeni 5S Denetimi",
    fivesScoreHint:"Her kategori 0-10 puan",
    auditArea:"Denetim Alanı", auditAreaPh:"Örn: Montaj Hattı 1",
    auditor_:"Denetçi", auditorPh:"Denetçi adı",
    auditDate:"Denetim Tarihi", totalScore:"Toplam Puan", notes:"Notlar",
    saveFivesAudit:"Denetimi Kaydet",
    lastAuditRadar:"Son Denetim Radar Grafiği", fivesCategoryScores:"5S Kategori Puanları",
    auditHistory:"Denetim Geçmişi", noAuditYet:"Henüz denetim kaydı yok",
    noFivesAudits:"Henüz 5S denetimi yapılmadı.",
    date_:"Tarih", area_:"Alan", total_:"Toplam",
    searchPlaceholder:"Öneri başlığı ara...",
    noKaizen:"Henüz kaizen önerisi yok. İlk öneriyi ekleyin!", noMatch:"Eşleşen öneri bulunamadı.",
    kaizenCategoryDist:"Kaizen Kategori Dağılımı", sevenMuda:"7 Muda (Lean İsraf Türleri)",
    mudaOverprod:"Aşırı Üretim", mudaOverprodDesc:"İhtiyaçtan fazla üretim",
    mudaWaiting:"Bekleme", mudaWaitingDesc:"Makine/malzeme/bilgi bekleme",
    mudaTransport:"Gereksiz Taşıma", mudaTransportDesc:"Malzeme transferi",
    mudaOverproc:"Aşırı İşleme", mudaOverprocDesc:"Gereksiz işlem adımları",
    mudaInventory:"Stok Fazlası", mudaInventoryDesc:"Aşırı hammadde/WIP",
    mudaMotion:"Gereksiz Hareket", mudaMotionDesc:"Operatör hareketi",
    mudaDefect:"Hata/Yeniden İşle", mudaDefectDesc:"Kalite hataları",
    count_:"Sayı", noData:"Veri yok",
    totalSuggestions_:"Toplam Öneri", completedCount:"Tamamlanan",
    completionRate:"Tamamlanma Oranı", totalSaving_:"Toplam Tasarruf",
    fivesAuditCount:"5S Denetim Sayısı", avgFivesScore_:"Ort. 5S Puanı",
    pcs:"adet", suggestion__:"öneri",
    pdcaInfo:"PDCA: Plan → Do → Check → Act — Her kaizen önerisinin 4 aşamalı uygulama döngüsü",
    pdcaPlanDesc:"Problem analizi, hedef belirleme, çözüm planlama",
    pdcaDoDesc:"Pilotta uygulama, kaynak tahsisi, aksiyon alma",
    pdcaCheckDesc:"Sonuç ölçümü, hedef karşılaştırma, analiz",
    pdcaActDesc:"Standartlaştırma veya revize, yaygınlaştırma",
    suggestionInStage:"öneri bu aşamada",
    activePdca:"Aktif PDCA Süreçleri", noActivePdca:"Aktif PDCA süreci bulunamadı",
    kaizen_:"Kaizen", pdcaPhase:"PDCA Aşaması", responsible:"Sorumlu",
    totalEstSaving:"Toplam Tahmini Tasarruf", completedKaizen:"Tamamlanan Kaizen",
    avgSavingPerK:"Ort. Tasarruf/Kaizen",
    categorySavingAnalysis:"Kategori Bazlı Tasarruf Analizi",
    realized:"Gerçekleşen", completed_:"tamamlandı",
    noKaizenData:"Kaizen verisi bulunamadı", roiAnalysis:"Tamamlanan Kaizen ROI Analizi",
    implCost:"Uygulama Maliyeti", payback:"Geri Ödeme", monthShort:"ay",
    noCompletedKaizen:"Tamamlanan kaizen bulunamadı",
    sysInfo:"Sistem üretim verilerini analiz ederek otomatik kaizen önerileri üretiyor.",
    thresholdSettings:"Eşik Ayarları", thresholdValues:"Analiz Eşik Değerleri",
    oeeThreshold:"OEE Eşiği (%)", fireThreshold:"Fire Oranı Eşiği (%)",
    tempThreshold:"Sıcaklık Eşiği (°C)", energyThreshold:"Enerji Maliyet Eşiği (₺)",
    reanalyze:"Yeniden Analiz Et",
    noSuggestions:"Sistem Önerisi Yok",
    noSuggestionsNote:"Tüm makineler belirlenen eşik değerleri içinde çalışıyor.",
    machine_:"Makine", saving_:"tasarruf", recommendedActions:"Önerilen Aksiyonlar",
    errFetch:"Kaizen verileri alınamadı", errGeneric:"Hata",
    errAreaAuditor:"Alan ve denetçi zorunlu.", errTitleProblem:"Başlık ve problem açıklaması zorunlu.",
  },

  // Dashboard PL & extra
  pl: {
    title: "Kar / Zarar Özeti (Son 30 Gün)",
    salesRevenue: "Satış Geliri",
    grossProfit: "Brüt Kâr",
    opExpense: "Faaliyet Gideri",
    netProfitLoss: "Net Kâr/Zarar",
    incomeItems: "📈 GELİR KALEMLERİ",
    expenseItems: "📊 GİDER KALEMLERİ",
    scrapRevenue: "Hurda Geliri",
    returnLoss: "İade Gelir Kaybı",
    brutProfit: "Brüt Kâr",
    productionCost: "Üretim Maliyeti",
    fireLoss: "Fire Kaybı",
    labor: "İşçilik (Bordro)",
    energy: "Enerji",
    maintenance: "Bakım",
    totalExpense: "Toplam Gider",
    personnel: "personel",
    normal: "Normal",
    overtime: "Fazla mesai",
    labor_short: "İşçilik",
    parts: "Parça",
    netProfit: "NET KÂR/ZARAR",
  },

  userManagement: {
    title: "Kullanıcı Yönetimi",
    subtitle: "Kullanıcılar, roller ve modül erişimlerini yönetin",

    roles: {
      admin: "Sistem Yöneticisi",
      manager: "Genel Müdür",
      production_manager: "Üretim Müdürü",
      quality_manager: "Kalite Müdürü",
      warehouse_chief: "Depo Şefi",
      maintenance_chief: "Bakım Şefi",
      hr_manager: "İK Müdürü",
      accountant: "Muhasebe",
      technician: "Teknisyen",
      warehouse: "Depo Görevlisi",
      operator: "Operatör",
      purchasing: "Satın Alma",
      dis_ticaret_mudur: "Dış Ticaret Müdürü",
      dis_ticaret_uzman: "Dış Ticaret Uzmanı",
      dis_ticaret_temsilci: "Dış Ticaret Temsilcisi",
      ic_satis_mudur: "Yurt İçi Satış Müdürü",
      ic_satis_uzman: "Yurt İçi Satış Uzmanı",
      ic_satis_temsilci: "Yurt İçi Satış Temsilcisi",
    },

    departments: {
      foreignTrade: "Dış Ticaret",
      domesticSales: "Yurt İçi Satış",
    },

    modules: {
      dashboard: "Dashboard",
      machines: "Makineler",
      workorders: "İş Emirleri",
      quality: "Kalite & Sevkiyat",
      stock: "Stok",
      maintenance: "Bakım & Servis",
      energy: "Enerji",
      kaizen: "Kaizen",
      lean: "Lean",
      fives: "5S Denetim",
      hr: "İK & Bordro",
      shifts: "Vardiya Planlama",
      reports: "Raporlar",
      admin: "Fabrika Paneli",
      users: "Kullanıcı Yönetimi",
      financial: "Finansal",
      ncr: "NCR & CAPA",
      scrap: "Scrap & Recycling",
      sales: "Satış Siparişleri",
      purchasing: "Satın Alma",
    },

    regions: {
      domestic: "Yurt İçi",
      foreign: "Yurt Dışı",
      all: "Tümü",
    },

    levels: {
      manager: "Müdür",
      chief: "Uzman",
      representative: "Temsilci",
    },

    usernameRequired: "Kullanıcı adı zorunlu.",
    passwordRequired: "Şifre zorunlu.",
    genericError: "Hata",
    editUser: "Kullanıcı Düzenle",
    newUser: "Yeni Kullanıcı",
    username: "Kullanıcı Adı",
    role: "Rol",
    password: "Şifre",
    newPassword: "Yeni Şifre (boş bırakılırsa değişmez)",
    passwordLeaveBlank: "Değiştirmek istemiyorsanız boş bırakın",
    region: "Bölge",
    level: "Seviye",
    select: "— Seçiniz —",
    cancel: "İptal",
    save: "Kaydet",
    create: "Oluştur",
    update: "Güncelle",
    activeUser: "Aktif kullanıcı",
    saving: "Kaydediliyor...",
    addUser: "Kullanıcı Ekle",
    loading: "Yükleniyor...",
    noUsers: "Kullanıcı bulunamadı",
    totalUsers: "Toplam Kullanıcı",
    active: "Aktif",
    passive: "Pasif",
    roleCount: "Rol Sayısı",
    usersTab: "Kullanıcılar",
    permissionsTab: "Modül Erişimleri",
    salesRegion: "Satış Bölgesi",
    status: "Durum",
    actions: "İşlemler",
    you: "Sen",
    edit: "Düzenle",
    delete: "Sil",

    permissionsLocked:
      "Admin ve Genel Müdür rollerinin erişimi değiştirilemez — tüm modüllere erişimleri vardır.",
    moduleAccess: "Modül Erişimleri",
    allModulesAccess: "Bu rol tüm modüllere erişebilir",
    modulesAccessCount: "{count} modüle erişim var",
    selectAll: "Tümünü Seç",
    clear: "Temizle",
    fullAccess: "Bu rol tüm modüllere tam erişime sahiptir",
    permissionsSaved: "Erişim ayarları kaydedildi!",
    savePermissions: "Erişimleri Kaydet",
    accessSummary: "Tüm Roller — Erişim Özeti",
    module: "Modül",

    deleteUser: "Kullanıcıyı Sil",
    deleteConfirm: "{username} kullanıcısını silmek istediğinize emin misiniz?",
    irreversible: "Bu işlem geri alınamaz.",
    yesDelete: "Evet, Sil",
  },

  ncrPage: {
    severityMinor: "Minör",
    severityMajor: "Majör",
    severityCritical: "Kritik",

    statusOpen: "Açık",
    statusUnderReview: "İncelemede",
    statusPendingApproval: "Onay Bekliyor",
    statusApproved: "Onaylandı",
    statusClosed: "Kapatıldı",
    statusCancelled: "İptal",

    dispositionRework: "Yeniden İşle",
    dispositionRemanufacture: "Yeniden Üret",
    dispositionReplacement: "Ürün Değişimi",
    dispositionScrap: "Hurda",
    dispositionUseAsIs: "Olduğu Gibi Kullan",
    dispositionReturnSupplier: "Tedarikçiye İade",
    dispositionPending: "Karar Bekliyor",

    categoryDimensional: "Boyutsal",
    categoryVisual: "Görsel",
    categoryFunctional: "Fonksiyonel",
    categoryMaterial: "Malzeme",
    categoryProcess: "Proses",
    categoryDocumentation: "Dokümantasyon",
    categoryAssembly: "Montaj",
    categorySupplier: "Tedarikçi",
    categoryWelding: "Kaynak",
    categoryProduction: "Üretim",
    categoryQuality: "Kalite",
    categoryCustomer: "Müşteri",
    categoryOther: "Diğer",

    capaStatusOpen: "Açık",
    capaStatusInProgress: "Devam Ediyor",
    capaStatusCompleted: "Tamamlandı",
    capaStatusVerified: "Doğrulandı",
    capaStatusClosed: "Kapatıldı",

    priorityLow: "Düşük",
    priorityMedium: "Orta",
    priorityHigh: "Yüksek",
    priorityCritical: "Kritik",


    // New NCR form
    newNcrTitle: "Yeni NCR Kaydı",
    newNcrSubtitle: "Uygunsuzluk Raporu — Uygunsuz Ürün Kaydı",
    basicInformation: "Temel Bilgiler",
    sourceType: "Kaynak Tipi",
    detectionDate: "Tespit Tarihi",
    department: "Departman",
    departmentPlaceholder: "Üretim, Kalite...",
    productCode: "Ürün Kodu",
    productCodePlaceholder: "Ürün kodu...",
    workOrderNo: "İş Emri No",
    salesOrderNo: "Sipariş No",
    customer: "Müşteri",
    customerPlaceholder: "Müşteri adı",
    nonconformityDetails: "Uygunsuzluk Detayları",
    affectedQuantity: "Etkilenen Miktar",
    costImpact: "Maliyet Etkisi",
    nonconformityDescription: "Uygunsuzluk Açıklaması",
    nonconformityPlaceholder: "Uygunsuzluğu detaylı açıklayın...",
    createNcr: "NCR Oluştur",

    editNcr: "NCR Düzenle",
    sourceInternalAudit: "İç Tetkik",
    analysisDecision: "Analiz & Karar",
    rootCauseAnalysis: "Kök Neden Analizi",
    rootCausePlaceholder: "Neden oluştu? 5-Neden, Balık Kılçığı...",
    immediateActionPlaceholder: "Hemen alınan önlem nedir?",
    notes: "Notlar",
    update: "Güncelle",

    ncrProductRequired: "Ürün kodu zorunlu",
    ncrDescriptionRequired: "Açıklama zorunlu",
    ncrQuantityRequired: "Etkilenen miktar zorunlu ve 0'dan büyük olmalı",
    ncrDepartmentRequired: "Departman zorunlu",
    ncrCustomerRequired: "Müşteri zorunlu",
    ncrSaveFailed: "Kaydedilemedi",

    sourceQualityCheck: "Kalite Kontrol",
    sourceProduction: "Üretim",
    sourceSupplier: "Tedarikçi",
    sourceCustomerComplaint: "Müşteri Şikayeti",
    sourceOther: "Diğer",

    severityMinorOption: "Minör — Küçük",
    severityMajorOption: "Majör — Büyük",
    severityCriticalOption: "Kritik — Acil",

    criticalNcrTitle: "KRİTİK NCR",
    criticalNcrInfo: "Kalite Müdürü → Üretim Müdürü → Genel Müdür onay zinciri gerektirir.",
    majorNcrTitle: "MAJOR NCR",
    majorNcrInfo: "Kalite Müdürü ve Üretim Müdürü onayı gerektirir.",

    // Customer Return form
    returnTitle: "Müşteri İadesi",
    returnSubtitle: "İade kaydı → Otomatik NCR açılır, ilgili birimler bildirilir",
    returnType: "İade Tipi",
    returnRefund: "Para İadesi",
    returnReplacement: "Ürün Değişimi",
    returnCustomerName: "Müşteri Adı",
    returnCustomerPlaceholder: "Müşteri adı yazın...",
    returnSelectOrder: "Sipariş Seç",
    returnSelectOrderPlaceholder: "Sipariş seçin",
    returnSelectProduct: "Ürün Seç",
    returnSelectProductPlaceholder: "Ürün seçin",
    returnQuantity: "İade Miktarı",
    piecesSold: "adet satıldı",
    returnDate: "İade Tarihi",
    severity: "Şiddet",
    returnReason: "İade Nedeni",
    returnReasonPlaceholder: "Müşteri neden iade etti? Detaylı açıklayın...",
    cancel: "İptal",
    saving: "Kaydediliyor...",
    createReturnRecord: "İade Kaydı Oluştur",
    returnProductRequired: "Ürün kodu zorunlu",
    returnCustomerRequired: "Müşteri zorunlu",
    returnQuantityRequired: "Miktar zorunlu",
    returnSaveFailed: "Kaydedilemedi",

    // NCR quality cost
    costInternal: "İç Hata",
    costInternalHint: "İşçilik, makine",
    costExternal: "Dış Hata",
    costExternalHint: "Nakliye, ceza",
    costRework: "Yeniden İşleme",
    costReworkHint: "Fason, operasyon",
    costOtherImpact: "Diğer Etki",
    costOtherImpactHint: "Genel maliyet",
    total: "Toplam",
    recurrenceWarning: "Bu ürün {count}. kez NCR aldı!",
    saveCost: "Maliyeti Kaydet",


    // NCR Detail
    genericError: "Hata",
    closeConfirm: "NCR kapatılacak. Emin misiniz?",
    closedNote: "Kapatıldı",
    category: "Kategori",
    capaCount: "CAPA Sayısı",
    rootCause: "Kök Neden",
    immediateAction: "Acil Önlem",
    notEnteredYet: "Henüz girilmedi",
    approvalChain: "Onay Zinciri",
    qualityManager: "Kalite Müdürü",
    productionManager: "Üretim Müdürü",
    generalManager: "Genel Müdür",
    pending: "Bekliyor",
    notRequired: "Gerekli değil",
    approvalDecision: "Onay / Karar Ver",
    decision: "Karar",
    note: "Not",
    approvalNotePlaceholder: "Onay notu...",
    processing: "İşleniyor...",
    approveApply: "Onayla & Uygula",
    closeNcr: "NCR'ı Kapat",
    remanufactureInfo: "Onayda otomatik iş emri açılır.",
    reworkInfo: "Onayda otomatik Rework iş emri açılır (RWK-XXXX). Operatör mevcut ürünü düzeltecek.",
    replacementInfo: "Depoda stok varsa direkt sevkiyat oluşturulur. Yoksa RPL iş emri açılır.",
    returnSupplierInfo: "Satın alma departmanı bildirim alacak.",
    scrapInfo: "Onayda hurda modülüne otomatik kayıt gider.",
    scrapRevenue: "HURDA GELİRİ",
    scrapRevenuePlaceholder: "Hurdacıdan alınan tutar...",
    capaRecords: "CAPA Kayıtları",
    addCapa: "CAPA Ekle",
    noCapaForNcr: "Bu NCR için henüz CAPA oluşturulmadı.",
    // CAPA form
    newCapa: "Yeni CAPA",
    editCapa: "CAPA Düzenle",
    capaSubtitle: "Düzeltici / Önleyici Faaliyet",
    capaType: "CAPA Tipi",
    capaCorrectiveOption: "Düzeltici — Mevcut sorunu gider",
    capaPreventiveOption: "Önleyici — Tekrarı engelle",
    capaTitlePlaceholder: "CAPA başlığı...",
    problemStatement: "Problem Tanımı",
    problemStatementPlaceholder: "Problem ne?",
    analysisMethod: "Analiz Yöntemi",
    capaRootCausePlaceholder: "Kök neden analizi...",
    actionPlan: "Aksiyon Planı",
    actionPlanPlaceholder: "Ne yapılacak?",
    responsiblePerson: "Sorumlu Kişi",
    responsiblePersonPlaceholder: "Ad Soyad",
    actionCost: "Aksiyon Maliyeti",
    createCapa: "CAPA Oluştur",

    rootMethod5Why: "5 Neden",
    rootMethodFishbone: "Balık Kılçığı",
    rootMethodPareto: "Pareto",
    rootMethodFmea: "FMEA",
    rootMethodOther: "Diğer",

    capaTitleRequired: "Başlık zorunlu",
    capaTargetDateRequired: "Hedef tarih zorunlu",
    capaSaveFailed: "Kaydedilemedi",

    corrective: "Düzeltici",
    preventive: "Önleyici",
    responsible: "Sorumlu",
    target: "Hedef",
    qualityCostEntry: "Kalite Maliyet Girişi",
    approvalHistory: "Onay Geçmişi",
    close: "Kapat",


    // NCR main screen
    pageSubtitle: "Uygunsuzluk Raporu · Düzeltici & Önleyici Faaliyet · ISO 9001 Madde 8.7 & 10.2",
    totalNcr: "Toplam NCR",
    open: "Açık",
    underReview: "İncelemede",
    pendingApproval: "Onay Bekliyor",
    critical: "Kritik",
    totalCost: "Toplam Maliyet",
    loading: "Yükleniyor...",
    searchPlaceholder: "NCR no, ürün kodu, müşteri...",
    allSeverities: "Tüm Şiddetler",
    allStatuses: "Tüm Durumlar",
    ncrRecords: "NCR Kayıtları",
    noNcrRecords: "NCR kaydı bulunamadı",
    createFirstNcr: "İlk NCR'ı Oluştur",

    // CAPA & Analytics main screen
    title: "Başlık",
    type: "Tip",
    targetDate: "Hedef Tarih",
    progress: "İlerleme",
    priority: "Öncelik",
    severityDistribution: "Şiddet Dağılımı",
    categoryDistribution: "Kategori Dağılımı",
    decisionDistribution: "Karar Dağılımı",
    count: "Sayı",
    noData: "Veri yok",
    last30DaysNcr: "Son 30 Gün NCR",
    closedCount: "Kapatılan",
    totalCapa: "Toplam CAPA",

    noCapaRecords: "CAPA kaydı bulunamadı. NCR kaydından CAPA oluşturabilirsiniz.",

    // Customer Return main screen
    listTab: "NCR Listesi",
    returnsTab: "Müşteri İadesi",
    returnPaginationLabel: "iade",
    analyticsTab: "Analiz",
    addReturnRecord: "İade Kaydı Ekle",
    returnInfo: "Müşteri iadesi oluşturulduğunda otomatik NCR açılır, Kalite ve Üretim müdürlerine bildirim gönderilir. Satır üzerine tıklayarak NCR detayına ulaşabilirsiniz.",
    returnRecords: "Müşteri İade Kayıtları",
    records: "kayıt",
    product: "Ürün",
    date: "Tarih",
    status: "Durum",
    noReturnRecords: "Müşteri iade kaydı bulunamadı",
    piece: "adet",
  },


  productsPage: {
    title: "Ürün Kartları",
    mainSubtitle: "Ürün reçetesi (BOM) · Fason işlemler · Üretim rotası · MRP hesaplama",
    template: "📥 Şablon ▾",
    import: "📤 İçe Aktar ▾",
    newProductCard: "+ Yeni Ürün Kartı",
    editProductCard: "Ürün Kartı Düzenle",
    description: "Açıklama",
    descriptionOptional: "Açıklama (opsiyonel)",
    productInformation: "📋 Ürün Bilgileri",
    categoryPlaceholder: "Otomotiv, Tarım...",
    purchasedPart: "Satın Alınan Parça",
    semiFinishedType: "Yarı Mamül",
    showInSales: "Satışta Görünsün",
    inProcessQc: "İç Proses KK",
    stockable: "Stoğa Alınabilir",
    drawingFile: "📐 Teknik Çizim",
    pdfDocument: "📄 PDF Doküman",
    unitCostUpper: "BİRİM MALİYET",
    totalProducts: "Toplam Ürün",
    ownProduction: "Kendi Üretimi",
    externallyPurchased: "Dışarıdan Alınan",
    setKit: "Set/Kit",
    bomDefined: "BOM Tanımlı",
    allTypes: "Tüm Tipler",
    clickNewProductHint: "+ Yeni Ürün Kartı butonuna tıklayın",

    subtitle: "Ürün, BOM, maliyet ve üretim tanımlarını yönetin",

    loading: "Yükleniyor...",
    saving: "Kaydediliyor...",
    save: "💾 Kaydet",
    cancel: "İptal",

    productCode: "Ürün Kodu",
    productName: "Ürün Adı",
    productNameRequired: "Ürün kodu ve adı zorunlu.",
    productNamePlaceholder: "Ürün adını yazın...",

    type: "Tip",
    category: "Kategori",
    unit: "Birim",
    material: "Malzeme",
    materialPlaceholder: "St37, Alüminyum...",
    minimumStock: "Minimum Stok",
    reorderQuantity: "Yeniden Sipariş Miktarı",

    manufactured: "Üretilen",
    purchased: "Satın Alınan",
    set: "Set",
    service: "Hizmet",

    categoryFinished: "Mamul",
    categorySemiFinished: "Yarı Mamul",
    categoryRawMaterial: "Hammadde",
    productCategory: "Ürün Kategorisi",
    categoryMachinedPart: "İşlenmiş Parça",
    categoryCommercialProduct: "Ticari Ürün",
    categoryConsumable: "Sarf",

    requiresAssembly: "Montaj Gerekli",

    unitCost: "Birim Maliyet",
    salePrice: "Satış Fiyatı",

    searchPlaceholder: "🔍 Ürün kodu, adı veya kategori ara...",
    noProducts: "Henüz ürün kartı yok",
    noMatch: "Eşleşen ürün bulunamadı",

    bom: "BOM",
    outsource: "Fason",
    sales: "Satış",

    templateProducts: "📦 Ürün Kartları",
    templateBom: "🔩 BOM / Reçete",
    templateOutsource: "🏭 Fason İşlemler",
    export: "📊 Dışa Aktar",

    raw: "Hammadde",
    purchasedMaterial: "Satın Alınan",
    semiFinished: "Yarı Mamül",
    subAssembly: "Alt Montaj",

    bomTree: "BOM Ağacı",
    bomDataNotFound: "BOM verisi bulunamadı",
    mainWorkOrder: "Ana İş Emri",
    sequenceNo: "Sıra No",
    totalMaterialCost: "Toplam malzeme maliyeti",
    createAssemblyWorkOrder: "🔧 Montaj İş Emri Oluştur",

    materialColumn: "Malzeme",
    quantity: "Miktar",
    stock: "Stok",
    cost: "Maliyet",

    detailGeneralInfo: "📋 Genel Bilgi",
    detailRecipe: "🔩 Reçete",
    detailOutsource: "🏭 Fason",
    detailOperations: "⚙️ Operasyonlar",
    detailBomTree: "🌳 BOM Ağacı",
    detailMrpCost: "📊 MRP / Maliyet",
    detailFiles: "📁 Dosyalar",

    drawingNo: "Çizim No",
    revision: "Revizyon",
    weight: "Ağırlık",
    standardTime: "Standart Süre",

    costSummary: "💰 Maliyet Özeti",
    rawMaterialCost: "Hammadde",
    outsourceCost: "Fason",
    laborCost: "İşçilik",
    totalCost: "Toplam",
    profitMargin: "Kar Marjı",

    deleteConfirm: "Silinsin mi?",

    productRecipeTitle: "🔩 Ürün Reçetesi (BOM)",
    addMaterial: "+ Malzeme Ekle",
    materialName: "Malzeme Adı",
    materialCode: "Malzeme Kodu",
    unitPrice: "Birim Fiyat",
    noMaterials: "Malzeme eklenmemiş.",

    select: "Seçin",
    sequence: "Sıra",
    operation: "İşlem",
    supplier: "Tedarikçi",
    leadTime: "Teslimat",
    leadTimeDays: "Teslimat (gün)",

    outsourceTitle: "🏭 Fason İşlemler",
    addOutsource: "+ Fason Ekle",
    noOutsource: "Fason işlem tanımlanmamış.",

    productionOperationsTitle: "⚙️ Üretim Operasyonları (Rota)",
    addOperation: "+ Operasyon Ekle",
    operationName: "Operasyon Adı",
    operationPlaceholder: "Tornalama, Frezeleme...",
    department: "Departman",
    machine: "Makine",
    setup: "Hazırlık",
    setupMinutes: "Hazırlık (dk)",
    cycle: "Çevrim",
    cycleMinutes: "Çevrim (dk)",
    noOperations: "Operasyon tanımlanmamış.",

    forPieces: "adet için",
    laborSsi: "İşçilik + SGK",
    shortageWarning: "⚠️ Eksik malzeme var! Üretim başlamadan önce satın alma yapılması gerekiyor.",

    unitQuantity: "Birim Miktar",
    totalRequired: "Toplam Gereken",
    inStock: "Depoda",
    shortage: "Eksik",
    status: "Durum",
    ready: "✓ Hazır",
    missing: "✗ Eksik",

    calculate: "Hesapla",
    enterQtyCalculate: "Miktar girin ve \"Hesapla\" butonuna basın",

    // RC1.6I.3 — final Products localization
    error: "Hata",
    connectionError: "Bağlantı hatası",
    deleteError: "Silme hatası",
    delete: "Sil",
    download: "İndir",

    productType: "Ürün Tipi",
    productLabel: "ürün",

    fileOther: "📁 Diğer",
    fileUploaded: "✅ Dosya yüklendi",
    fileDeleted: "✅ Dosya silindi",
    uploadFile: "📤 Dosya Yükle",
    fileNotePlaceholder: "Dosya hakkında not...",
    selectFile: "📁 Dosya Seç",

    operationNameRequired: "İşlem Adı *",
    outsourceOperationPlaceholder: "Kumlama, Galvaniz...",

    mrpCalculation: "📊 MRP Hesaplama"

  },

  assemblyPage: {
    title: "Montaj Modülü",
    subtitle: "Montaja hazır ve devam eden iş emirleri",
    refresh: "Yenile",
    loading: "Yükleniyor...",
    noReadyWorkOrders: "Montaja hazır iş emri yok",
    noReadyWorkOrdersHint: "Tüm alt iş emirleri tamamlandığında buraya gelir",
    completedAssemblies: "Tamamlanan Montajlar",
    hide: "Gizle",
    show: "Göster",
    perPage: "Sayfa başı",
    records: "kayıt",
    piece: "adet",

    currentStatus: "Mevcut Durum",
    materialsLoading: "Malzemeler yükleniyor...",
    allMaterialsReady: "Tüm malzemeler hazır — Montaj başlatılabilir",
    missingMaterialPurchaseRequired: "Eksik malzeme var — Satın alma talebi oluşturulmalı",
    productionMaterials: "Üretimden Gelen Malzemeler",
    warehouseMaterials: "Depodan Alınacak Malzemeler",
    required: "Gerekli",
    inWarehouse: "Depoda",
    warehouseReady: "Depoda Hazır",
    missing: "Eksik",

    ready: "✅ Hazır",
    waiting: "⏳ Bekleniyor",
    delivered: "✅ Teslim Alındı",
    requestSent: "📨 Talep Gönderildi",
    inStock: "🟢 Depoda Var",
    outOfStock: "🔴 Depoda Yok",
    request: "Talep Et",

    startAssembly: "Montajı Başlat",
    completeAssembly: "Montajı Tamamla",
    completedQuantity: "Tamamlanan Miktar",
    notes: "Notlar",
    cancel: "İptal",
    approve: "Onayla",

    assemblyStarted: "Montaj başladı ✅",
    assemblyCompletedSuccess: "Montaj tamamlandı ✅",
    warehouseRequestSent: "Depo talebi gönderildi ✅",
    requestCreateFailed: "Talep oluşturulamadı",
    connectionError: "Bağlantı hatası",
    error: "Hata",

    finalQcWaiting: "Final KK Bekleniyor",
    finalQcWaitingHint: "Montaj tamamlandı. Kalite & Sevkiyat modülünden Final KK yapınız.",
    finalQcPassedCompleted: "Final KK Geçti - Tamamlandı",
    completedReadyShipment: "Bu iş emri başarıyla tamamlanmış ve sevkiyata hazır.",

    statusDraft: "Taslak",
    statusPlanned: "Planlandı",
    statusReleased: "Serbest",
    statusInProgress: "Üretimde",
    statusQcPending: "İç Proses KK Bekliyor",
    statusQcPassed: "İç Proses KK Geçti",
    statusAssemblyPending: "Montaj Bekliyor",
    statusAssemblyInProgress: "Montajda",
    statusAssemblyDone: "Montaj Tamamlandı",
    statusAssemblyCompleted: "Montaj Tamamlandı",
    statusFinalQcPending: "Final KK Bekliyor",
    statusFinalQcPassed: "Final KK Geçti",
    statusFinalQcFailed: "Final KK Kaldı",
    statusFinalQc: "Final KK",
    statusCompleted: "Tamamlandı",
    statusCancelled: "İptal",
  },


  aiAssistant: {
    title: "Opement IQ Asistan",
    welcome: "Merhaba! Ben Opement IQ Akıllı Asistan. Fabrika verileriniz hakkında sorularınızı yanıtlayabilirim. 🏭",
    online: "Çevrimiçi",
    offline: "Çevrimdışı",
    thinking: "Düşünüyor...",
    placeholder: "Soru sorun...",
    errorPrefix: "Hata",
    unknownError: "Bilinmeyen hata",
    connectionError: "Bağlantı hatası. Lütfen tekrar deneyin.",
    speechUnsupported: "Tarayıcınız sesli girişi desteklemiyor.",
    quickOee: "Bu ay OEE kaç?",
    quickCriticalStock: "Kritik stok var mı?",
    quickScrapRate: "Son fire oranı nedir?",
    quickMaintenance: "Bekleyen bakım var mı?",
  },

  adminPanel: {
    title: "🎛️ Fabrika Yönetim Paneli",
    subtitle: "Canlı izleme · Drag-drop düzen · Otomatik yenileme (30sn)",
    lastUpdate: "Son",
    reset: "Sıfırla",
    save: "Kaydet",
    edit: "Düzenle",
    tabPanel: "🎛️ Fabrika Paneli",
    tabPermissions: "🔐 İçerik Yetkileri",
    editModeHint: "Düzenleme Modu — Widget'ları sürükleyerek yeniden sırala",
    panelLoading: "Panel yükleniyor...",

    widgetTitles: {
      oeeGauges: "🏭 OEE - Makine Bazlı",
      productionChart: "📈 Üretim Grafiği",
      alarmList: "🚨 Son Alarmlar",
      energy: "⚡ Enerji Tüketimi",
      criticalStock: "📦 Kritik Stok Seviyeleri",
      kaizenSummary: "🔄 Kaizen Özeti",
      machineMap: "🗺️ Makine Durum Haritası",
      lossSummary: "💰 Para Kaybı Analizi",
      mrpCost: "💰 MRP / Maliyet Bilgisi",
    },
  

    loading: "Yükleniyor...",
    permissionsTitle: "🔐 İçerik Yetki Yönetimi",
    saved: "Kaydedildi",
    saving: "Kaydediliyor...",
    enableAll: "Tümünü Aç",
    disableAll: "Tümünü Kapat",
    visible: "Görünür",
    hidden: "Gizli",
    roleSelection: "Rol Seçimi",
    moduleSelection: "Modül Seçimi",

    permissionModules: {
      dashboard: "📊 Dashboard",
      reports: "📄 Raporlar",
      salesorders: "🛒 Satış Siparişleri",
      machines: "🏭 Makineler",
      workorders: "📋 İş Emirleri",
      products: "📦 Ürünler",
      stock: "🏪 Stok",
      purchasing: "🛒 Satın Alma",
      hr: "👥 İK & Bordro",
    },

    roles: {
      admin: "👑 Sistem Yöneticisi",
      manager: "🏢 Genel Müdür",
      production_manager: "🏭 Üretim Müdürü",
      quality_manager: "✅ Kalite Müdürü",
      warehouse_chief: "📦 Depo Şefi",
      maintenance_chief: "🔧 Bakım Şefi",
      hr_manager: "👥 İK Müdürü",
      warehouse: "🏪 Depo Görevlisi",
      operator: "👷 Operatör",
      purchasing: "🛒 Satın Alma",
      dis_ticaret_mudur: "✈️ Dış Ticaret Müdürü",
      dis_ticaret_uzman: "✈️ Dış Ticaret Uzmanı",
      dis_ticaret_temsilci: "✈️ Dış Ticaret Temsilcisi",
      ic_satis_mudur: "🏠 Yurt İçi Satış Müdürü",
      ic_satis_uzman: "🏠 Yurt İçi Satış Uzmanı",
      ic_satis_temsilci: "🏠 Yurt İçi Satış Temsilcisi",
    },

    permissionItems: {
      stat_oee: "📊 OEE Kartı",
      stat_production: "🏭 Toplam Üretim Kartı",
      stat_alarms: "🚨 Aktif Alarmlar Kartı",
      stat_loss: "💰 Aylık Kayıp Kartı",
      widget_pl: "💹 Kar/Zarar Özeti",
      widget_oee_gauges: "📈 OEE Makine Bazlı",
      widget_production: "📈 Üretim Grafiği",
      widget_kaizen: "🔄 Kaizen Özeti Widget",
      widget_loss: "💸 Para Kaybı Widget",
      tab_dashboard: "📊 Yönetim Paneli Sekmesi",
      tab_sales_perf: "💼 Satış Performansı Sekmesi",
      tab_personnel: "👥 Personel Raporları Sekmesi",
      tab_reports: "📄 Rapor Oluştur Sekmesi",
      tab_history: "📋 Geçmiş Sekmesi",
      btn_new_order: "➕ Yeni Sipariş / İş Emri",
      btn_cancel: "🚫 İptal Butonu",
      col_temperature: "🌡️ Sıcaklık Kolonu",
      fault_history: "🔧 Arıza Geçmişi",
      btn_export_excel: "📥 Excel Dışa Aktar",
      btn_complete: "✅ Üretimi Tamamla",
      btn_runtime_start: "▶ Üretimi Başlat",
      btn_downtime_reason: "⏸ Duruş Nedeni Seç",
      col_operator: "👤 Operatör Kolonu",
      tab_materials: "📋 Ürün Reçetesi Sekmesi",
      tab_audit: "📜 Geçmiş Sekmesi",
      action_tree: "🌳 Ağaç İşlemi",
      action_detail: "👁 Detay İşlemi",
      col_supplier: "🏢 Tedarikçi Kolonu",
      col_salary: "💰 Maaş Bilgisi",
      tab_leave: "🏖️ İzin Sekmesi",
    },

    widgets: {
      production: "Üretim",
      today: "Bugün",
      cost: "Maliyet",
      completed: "Tamamlandı",
      inProgress: "Devam Eden",
      pending: "Bekliyor",
      total: "Toplam",
      saving: "Tasarruf",
      statusRunning: "Çalışıyor",
      statusStopped: "Durdu",
      statusFault: "Arıza",
      statusMaintenance: "Bakım",
      statusIdle: "Bekliyor",
      dataLoading: "Veri yükleniyor...",
      noData: "Veri yok",
      noActiveAlarms: "Aktif alarm yok",
      noChartData: "Grafik verisi yok",
      noCriticalStock: "Kritik stok yok",
      noKaizen: "Kaizen kaydı yok",
      noFinancialData: "Finansal veri yok",
      dailyLoss: "Günlük Kayıp",
      monthlyLoss: "Aylık Kayıp",
      machine: "Makine",
    },
},
};

export default tr;
